// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:100,200,300,regular,500,600,700,800,900,100italic,200italic,300italic,italic,500italic,600italic,700italic,800italic,900italic);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Множественный выбор учеников в модалке расписания */
.modal-multiselect-trigger {
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1.5px solid #d1d1e0;
  background: #fff;
}

.modal-multiselect-trigger--open {
  border-color: #6c3be4;
}

.modal-multiselect-dd {
  position: absolute;
  top: 110%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ece9f7;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(108, 59, 228, 0.12);
  padding: 10px;
  z-index: 40;
  max-height: 280px;
  overflow-y: auto;
}

.modal-multiselect-search {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #e0e0ef;
  margin-bottom: 8px;
}

.modal-multiselect-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 8px;
  border-radius: 8px;
}

.modal-multiselect-item:hover {
  background: #faf8ff;
}

.modal-multiselect-item input[type=checkbox] {
  width: 16px;
  height: 16px;
}

/* Переключатель режима назначения занятий */
.assign-switch {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  background: #f3f0fa;
  border: 1px solid #ece9f7;
  border-radius: 10px;
  padding: 4px;
}

.assign-switch-btn {
  background: transparent;
  border: none;
  border-radius: 8px;
  padding: 8px 10px;
  font-weight: 600;
  color: #6c3be4;
  cursor: pointer;
}

.assign-switch-btn.is-active {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

body {
  margin: 0;
  padding: 0;
  font-family: Montserrat;
}

* {
  font-family: Montserrat;
}

[class*=__container] {
  max-width: 1170px;
  margin: 0px auto;
}

input {
  padding: 10px 20px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #cacaca;
  border-radius: 5px;
}
input:focus {
  border: 1px solid #41424C;
  outline: none;
}

.button {
  width: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 10px 20px;
  background: #41424C;
  border-radius: 5px;
  color: #fff;
  text-decoration: none;
  box-sizing: border-box;
  transition: 0.3s;
}
.button:hover {
  background: rgba(76, 32, 187, 0.7058823529);
}

.Sidebar {
  height: 100vh;
  background: #41424C;
  width: 200px;
  position: fixed;
}
.Sidebar .logo {
  text-align: center;
  padding-top: 20px;
  font-size: 24px;
  color: #fff;
  font-weight: 700;
}
.Sidebar ul li {
  list-style: none;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 20px 0px;
}
.Sidebar ul li a {
  color: #fff;
  text-decoration: none;
}
.Sidebar ul li a.active {
  font-weight: 700;
}
.Sidebar .leave {
  position: absolute;
  text-align: center;
  left: 0;
  bottom: 20px;
  width: 100%;
}
.Sidebar .leave a {
  display: flex;
  justify-content: center;
  width: 100%;
  color: #fff;
  text-decoration: none;
}

.Header {
  width: 100%;
  background: #41424C;
  padding: 10px 0px;
}
.Header .Header__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Header .Header__container .logo {
  font-size: 22px;
  color: #fff;
  font-weight: 600;
}
.Header .Header__container .menu ul {
  display: flex;
  gap: 20px;
}
.Header .Header__container .menu ul li {
  list-style: none;
}
.Header .Header__container .menu ul li a {
  color: #fff;
  text-decoration: none;
}
.Header .Header__container .menu ul li a.active {
  border-bottom: 2px solid #d1d1d1;
}

.Auth {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Auth .AuthBlock {
  width: 400px;
  padding: 25px;
  box-sizing: border-box;
  box-shadow: 0px 0px 7px 0px rgba(34, 60, 80, 0.2);
  border-radius: 10px;
}
.Auth .AuthBlock .title {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
}
.Auth .AuthBlock .inputBlock {
  margin: 10px 0px;
}
.Auth .AuthBlock .passwordBlock {
  position: relative;
}
.Auth .AuthBlock .passwordBlock input {
  width: 100%;
  padding-right: 40px;
}
.Auth .AuthBlock .passwordBlock .toggleIcon {
  position: absolute;
  right: 10px;
  top: 55%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #888;
}
.Auth .AuthBlock .passwordBlock .toggleIcon:hover {
  color: #000;
}

.Home .Schedule .Schedule__collumn {
  width: 100%;
  height: 100%;
  background: #f1f1f1;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 5px;
}
.Home .Schedule .Schedule__collumn .title {
  text-align: center;
  color: #41424C;
  font-weight: 600;
  padding-bottom: 10px;
  border-bottom: 1px solid #dddddd;
}
.Home .Schedule .ScheduleBlockk {
  padding: 10px;
  background: #fff;
  margin: 10px 0px;
  font-size: 14px;
  border-radius: 5px;
  width: 100%;
  box-sizing: border-box;
}
.Home .Schedule .ScheduleBlockk .textBlock {
  margin: 5px 0px;
}
.Home .Schedule .ScheduleBlockk .textBlock span {
  font-weight: 500;
}
.Home .Schedule .ScheduleBlockk a {
  margin-top: 10px;
}

.News .News__container {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  padding-top: 20px;
}
.News .News__container .NewsBlock {
  width: 370px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(34, 60, 80, 0.2);
  border-radius: 5px;
}
.News .News__container .NewsBlock .image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}
.News .News__container .NewsBlock .body {
  padding: 10px;
  box-sizing: border-box;
}
.News .News__container .NewsBlock .body .date {
  font-size: 12px;
  opacity: 0.5;
  margin-bottom: 5px;
}
.News .News__container .NewsBlock .body .title {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 500;
}
.News .News__container .NewsBlock .body .text {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 10px;
  font-size: 15px;
}

.NewsFull .NewsFull__container {
  display: flex;
  padding-top: 20px;
  gap: 40px;
}
.NewsFull .NewsFull__container .left {
  width: 40%;
}
.NewsFull .NewsFull__container .left .image img {
  width: 100%;
  border-radius: 5px;
}
.NewsFull .NewsFull__container .right {
  width: 55%;
}
.NewsFull .NewsFull__container .right .title {
  font-size: 24px;
  font-weight: 600;
}
.NewsFull .NewsFull__container .right .text {
  margin-top: 10px;
}
.NewsFull .NewsFull__container .right .date {
  font-size: 12px;
  opacity: 0.5;
  margin-bottom: 5px;
  margin-top: 30px;
}

.AdminHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.AdminHeader .title {
  font-size: 20px;
  font-weight: 500;
}

.AdminGroups__container {
  display: flex;
  gap: 40px;
}
.AdminGroups__container .search {
  margin-top: 20px;
  margin-bottom: 20px;
}
.AdminGroups__container .table__title {
  display: flex;
  justify-content: space-between;
}
.AdminGroups__container .table__title .title {
  font-size: 14px;
  font-weight: 600;
}
.AdminGroups__container .table__title .title_group {
  width: 150px;
}
.AdminGroups__container .table__title .quantity__group {
  width: 180px;
}
.AdminGroups__container .table__title .rasp__group {
  width: 150px;
}
.AdminGroups__container .table__title .full_group {
  width: 150px;
}
.AdminGroups__container .GroupBlock {
  width: 100%;
  background: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
  margin: 10px 0px;
  display: flex;
  justify-content: space-between;
  text-align: start;
  box-sizing: border-box;
  align-items: center;
}
.AdminGroups__container .GroupBlock .title_group {
  width: 150px;
}
.AdminGroups__container .GroupBlock .quantity__group {
  width: 180px;
}
.AdminGroups__container .GroupBlock .rasp__group {
  width: 150px;
}
.AdminGroups__container .GroupBlock .rasp__group a {
  font-size: 12px;
  padding: 5px;
}
.AdminGroups__container .GroupBlock .full_group {
  width: 150px;
}
.AdminGroups__container .GroupBlock .full_group a {
  font-size: 12px;
  padding: 5px;
}

.content_admin {
  padding-top: 20px;
  width: 900px;
  margin-left: 240px;
  /*     &::-webkit-scrollbar{
          display: none;
      } */
  /*     &::-webkit-scrollbar-track{
          background: #000;
      } */
}

.AdminUsers .AdminUsers__container {
  display: flex;
  gap: 40px;
}
.AdminUsers .AdminUsers__container .search {
  margin-top: 20px;
}
.AdminUsers .AdminUsers__container .table__title {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.AdminUsers .AdminUsers__container .table__title .title {
  font-size: 14px;
  font-weight: 600;
}
.AdminUsers .AdminUsers__container .table__title .user_name {
  width: 140px;
}
.AdminUsers .AdminUsers__container .table__title .user_group {
  width: 80px;
}
.AdminUsers .AdminUsers__container .table__title .user_pay,
.AdminUsers .AdminUsers__container .table__title .user_rasp,
.AdminUsers .AdminUsers__container .table__title .user_full {
  width: 120px;
}
.AdminUsers .AdminUsers__container .UserBlock {
  width: 100%;
  background: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
  margin: 10px 0px;
  display: flex;
  justify-content: space-between;
  text-align: start;
  box-sizing: border-box;
  align-items: center;
}
.AdminUsers .AdminUsers__container .UserBlock .user_name {
  width: 140px;
  font-size: 12px;
}
.AdminUsers .AdminUsers__container .UserBlock .user_group {
  width: 80px;
  font-size: 14px;
}
.AdminUsers .AdminUsers__container .UserBlock .user_pay,
.AdminUsers .AdminUsers__container .UserBlock .user_rasp,
.AdminUsers .AdminUsers__container .UserBlock .user_full {
  width: 120px;
}
.AdminUsers .AdminUsers__container .UserBlock a {
  font-size: 12px;
  padding: 5px;
}

.AdminUsers__container .UserBlock {
  display: flex;
  align-items: center;
}

.AdminUsers__container .UserBlock > .title {
  flex: 1 1;
  min-width: 120px;
  max-width: 220px;
  text-align: left;
  padding: 0 8px;
}

.AdminUsers__container .UserBlock > .user_pay,
.AdminUsers__container .UserBlock > .user_rasp,
.AdminUsers__container .UserBlock > .user_full {
  min-width: 150px;
  max-width: 180px;
  text-align: center;
}

.admin-users-row {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.admin-users-schedule-btn {
  background: #4c20bb;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 16px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  margin-left: 12px;
  transition: background 0.2s;
}

.admin-users-schedule-btn:hover {
  background: #6c3be4;
}

.admin-users-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-users-modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  min-width: 320px;
  max-width: 400px;
}

.admin-users-modal-btn {
  padding: 6px 16px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #f5f5f5;
  color: #222;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.admin-users-modal-btn-primary {
  background: #6c3be4;
  color: #fff;
  border: none;
}

.admin-users-modal-btn-primary:hover {
  background: #4c20bb;
}

.ScheduleBlock, .ScheduleBlock.filled, .ScheduleBlock.empty {
  width: 100%;
  padding: 16px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px #ece9f7;
  margin-bottom: 12px;
  box-sizing: border-box;
  overflow: hidden;
  display: block;
}

.ScheduleBlock.empty {
  background: #f5f5f5;
  box-shadow: none;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.Schedule__column {
  width: 180px;
  min-width: 180px;
  max-width: 180px;
}

.scheduleblock-content {
  margin-bottom: 8px;
}

.scheduleblock-time {
  color: #6c3be4;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 2px;
}

.scheduleblock-group {
  font-weight: 500;
  margin-bottom: 2px;
}

.scheduleblock-subject {
  font-size: 14px;
  color: #222;
  margin-bottom: 2px;
}

.scheduleblock-comment {
  font-size: 13px;
  color: #888;
  margin-top: 2px;
}

.scheduleblock-actions {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.scheduleblock-edit-btn, .scheduleblock-details-btn {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.scheduleblock-edit-btn {
  background: none;
  border: 1px solid #6c3be4;
  color: #6c3be4;
  border-radius: 6px;
  padding: 4px 14px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.scheduleblock-edit-btn:hover {
  background: #6c3be4;
  color: #fff;
}

.scheduleblock-details-btn {
  background: #6c3be4;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 4px 14px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.scheduleblock-details-btn:hover {
  background: #4c20bb;
}

.admin-user-schedule-wrapper {
  padding-top: 24px;
}

.admin-user-back-btn {
  margin-bottom: 20px;
  background: #4c20bb;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 16px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.admin-user-back-btn:hover {
  background: #6c3be4;
}

.admin-user-title {
  margin-bottom: 24px;
  font-size: 22px;
  font-weight: 600;
}

.admin-users-table-wrapper {
  margin-top: 24px;
  overflow-x: auto;
}

.admin-users-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px #ece9f7;
  font-size: 15px;
}

.admin-users-table th, .admin-users-table td {
  padding: 14px 16px;
  text-align: left;
}

.admin-users-table th {
  background: #f5f5f5;
  font-weight: 600;
  font-size: 16px;
}

.admin-users-table tr {
  border-bottom: 1px solid #ece9f7;
}

.admin-users-table tr:last-child {
  border-bottom: none;
}

.admin-users-table td {
  vertical-align: middle;
}

.admin-user-full-wrapper {
  padding-top: 24px;
}

.admin-user-full-info {
  background: #f8f7fc;
  border-radius: 10px;
  padding: 24px 32px;
  font-size: 16px;
  margin-top: 16px;
  box-shadow: 0 2px 8px #ece9f7;
  max-width: 400px;
}

/* Выбор групп в профиле ученика */
.user-groups-picker {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.user-groups-trigger {
  background: #fff;
  border: 1.5px solid #d1d1e0;
  color: #333;
  border-radius: 10px;
  padding: 10px 14px;
  min-width: 260px;
  text-align: left;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.user-groups-trigger--open {
  border-color: #6c3be4;
}

.user-groups-dd {
  position: absolute;
  top: 48px;
  left: 0;
  width: 360px;
  background: #fff;
  border: 1px solid #ece9f7;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(108, 59, 228, 0.18);
  padding: 12px;
  z-index: 100;
}

.user-groups-dd-head {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.user-groups-search {
  flex: 1 1;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #e6e6ef;
  background: #fafaff;
}

.user-groups-dd-btn {
  background: #f4efff;
  color: #6c3be4;
  border: 1px solid #e8e3fb;
  border-radius: 10px;
  padding: 8px 12px;
  font-weight: 600;
}

.user-groups-dd-btn--clear {
  background: #f9f9fb;
  color: #666;
  border: 1px solid #e6e6ef;
}

.user-groups-list {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;
}

.user-groups-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
}

.user-groups-item:hover {
  background: #faf8ff;
}

.user-groups-item input[type=checkbox] {
  width: 16px;
  height: 16px;
}

.user-groups-chips {
  margin-top: 10px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.user-groups-chip {
  background: #f1edfe;
  color: #6c3be4;
  border: 1px solid #e8e3fb;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
}

.admin-groups-table-wrapper {
  margin-top: 24px;
  overflow-x: auto;
}

.admin-groups-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px #ece9f7;
  font-size: 15px;
  min-width: 480px;
}

.admin-groups-table th, .admin-groups-table td {
  padding: 12px 16px;
  text-align: left;
}

.admin-groups-table th.center, .admin-groups-table td.center {
  text-align: center;
}

.admin-groups-table th {
  background: #f7f7f9;
  font-weight: 600;
  font-size: 16px;
  border-bottom: 1px solid #ece9f7;
}

.admin-groups-table-row {
  background: #fff;
  border-radius: 8px;
  transition: background 0.2s;
}

.admin-groups-table-row:hover {
  background: #f8f7fc;
}

.admin-groups-drop-indicator td {
  padding: 0 !important;
}

.admin-groups-drop-indicator {
  height: 8px;
}

.admin-groups-drop-indicator td::after {
  content: "";
  display: block;
  height: 8px;
  background: #6c3be4;
  opacity: 0.25;
  border-radius: 4px;
}

.admin-groups-table-loading, .admin-groups-table-empty {
  text-align: center;
  color: #888;
  padding: 20px;
}

.admin-groups-table-name {
  font-weight: 500;
  font-size: 16px;
}

.admin-groups-table-count {
  text-align: center;
  font-size: 15px;
}

.admin-groups-table-actions {
  text-align: center;
}

.admin-groups-btn {
  background: #6c3be4;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 16px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
  margin-bottom: 2px;
}

.admin-groups-btn-secondary {
  background: #f5f5f5;
  color: #4c20bb;
  border: 1px solid #6c3be4;
}

.admin-groups-btn-secondary:hover {
  background: #ece9f7;
  color: #6c3be4;
}

.adminschedule-header {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  align-items: center;
}

.adminschedule-header-label {
  font-weight: 500;
}

.adminschedule-select {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.AdminSchedule-kanban {
  display: flex;
  gap: 24px;
}

.Schedule__column {
  flex: 1 1;
}

.adminschedule-title {
  text-align: center;
  margin-bottom: 12px;
}

.ScheduleBlock.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
  background: #f5f5f5;
  border-radius: 10px;
  margin-bottom: 12px;
  flex-direction: column;
}

.scheduleblock-empty-time {
  color: #888;
  font-size: 14px;
  margin-bottom: 4px;
}

.add-slot-btn {
  font-size: 28px;
  color: #6c3be4;
  background: none;
  border: none;
  cursor: pointer;
}

.scheduleblock-delete-btn {
  background: #e74c3c;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 4px 14px;
  font-size: 14px;
  margin-top: 4px;
}

.AdminGroups {
  padding: 0 0 70px 0;
  background: #f8f7fc;
  min-height: 100vh;
}

.AdminGroups__container {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.admin-groups-search {
  margin-top: 20px;
  margin-bottom: 20px;
  max-width: 400px;
}

.admin-groups-table-wrapper {
  margin-top: 24px;
  overflow-x: auto;
}

.admin-groups-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px #ece9f7;
  font-size: 15px;
  min-width: 480px;
}

.admin-groups-table th, .admin-groups-table td {
  padding: 14px 18px;
  text-align: left;
}

.admin-groups-table th {
  background: #f7f7f9;
  font-weight: 600;
  font-size: 16px;
  border-bottom: 1px solid #ece9f7;
}

.admin-groups-table-row {
  background: #f7f7f9;
  border-radius: 8px;
  transition: background 0.2s;
}

.admin-groups-table-row:hover {
  background: #f0ebff;
}

.admin-groups-table-loading, .admin-groups-table-empty {
  text-align: center;
  color: #888;
  padding: 20px;
}

.admin-groups-table-name {
  font-weight: 500;
  font-size: 16px;
}

.admin-groups-table-count {
  text-align: center;
  font-size: 15px;
}

.admin-groups-table-actions {
  text-align: center;
}

.admin-groups-btn {
  background: #6c3be4;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 16px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
  margin-bottom: 2px;
}

.admin-groups-btn-secondary {
  background: #f5f5f5;
  color: #4c20bb;
  border: 1px solid #6c3be4;
}

.admin-groups-btn-secondary:hover {
  background: #ece9f7;
  color: #6c3be4;
}

.admin-groups-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-groups-modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  min-width: 320px;
  max-width: 400px;
  box-shadow: 0 2px 12px #ece9f7;
}

.admin-groups-modal-title {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #6c3be4;
  text-align: center;
}

.admin-groups-modal-field {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
}

.admin-groups-modal-field label {
  margin-bottom: 4px;
  font-weight: 500;
}

.admin-groups-modal-field input {
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 15px;
}

.admin-groups-modal-error {
  color: #e74c3c;
  margin-bottom: 8px;
  text-align: center;
}

.admin-groups-modal-success {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
}

.admin-groups-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.admin-groups-modal-btn {
  padding: 6px 16px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #f5f5f5;
  color: #222;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.admin-groups-modal-btn-primary {
  background: #6c3be4;
  color: #fff;
  border: none;
}

.admin-groups-modal-btn-primary:hover {
  background: #4c20bb;
}

@media (max-width: 900px) {
  .Home .Schedule {
    flex-wrap: wrap;
    gap: 20px;
    justify-content: flex-start;
  }
  .Home .Schedule__collumn {
    width: 48%;
    min-width: 220px;
    max-width: 100%;
  }
  .Home__container, .News__container, .NewsFull__container {
    padding-left: 10px;
    padding-right: 10px;
  }
  .AdminUsers__container, .AdminGroupFull__container, .AdminRasp__container, .content_admin {
    flex-direction: column !important;
    gap: 0 !important;
    width: 100% !important;
    margin-left: 0 !important;
    padding: 0 6px !important;
    box-sizing: border-box;
  }
  .Sidebar {
    position: static !important;
    width: 100% !important;
    min-width: 0 !important;
    height: auto !important;
    box-shadow: none !important;
    margin-bottom: 16px;
  }
  .content_admin {
    width: 100% !important;
    margin-left: 0 !important;
    padding: 0 6px !important;
    box-sizing: border-box;
  }
  .AdminSchedule-kanban, .AdminRasp .AdminSchedule-kanban {
    display: flex !important;
    flex-direction: row !important;
    gap: 12px !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 16px;
    margin-bottom: 0;
    width: 100%;
    max-width: 100vw;
  }
  .Schedule__column {
    min-width: 220px !important;
    max-width: 260px !important;
    width: 90vw !important;
  }
  .AdminGroups__container {
    flex-direction: column !important;
    gap: 0 !important;
    width: 100% !important;
    margin-left: 0 !important;
    padding: 0 6px !important;
    box-sizing: border-box;
  }
  .content_admin {
    width: 100% !important;
    margin-left: 0 !important;
    padding: 0 6px !important;
    box-sizing: border-box;
  }
  .Sidebar, .admin-sidebar {
    display: none !important;
  }
  .AdminGroups {
    padding: 0 0 70px 0 !important;
  }
  .admin-groups-table {
    min-width: 320px;
    font-size: 13px;
  }
  .admin-groups-modal-content {
    min-width: 90vw;
    max-width: 98vw;
    padding: 16px;
  }
  .adminrasp-gradient-shadow {
    display: none !important;
  }
}
@media (max-width: 600px) {
  .Auth {
    align-items: flex-start;
    padding-top: 40px;
    height: auto;
  }
  .Auth .AuthBlock {
    width: 100%;
    min-width: 0;
    max-width: 98vw;
    padding: 16px;
    box-shadow: 0px 0px 4px 0px rgba(34, 60, 80, 0.13);
  }
  .Home .Schedule {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  .Home .Schedule__collumn {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    margin-bottom: 12px;
  }
  .ScheduleBlockk {
    font-size: 13px;
    padding: 8px;
  }
  .Home__container, .News__container, .NewsFull__container {
    padding-left: 6px;
    padding-right: 6px;
    padding-bottom: 80px;
    box-sizing: border-box;
  }
  .NewsFull__container {
    flex-direction: column !important;
    gap: 0 !important;
  }
  .NewsFull__container .left, .NewsFull__container .right {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
  }
  .NewsFull__container .left .image img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    margin-bottom: 12px;
  }
  .NewsFull__container .right .title {
    font-size: 20px;
    margin-top: 8px;
  }
  .AdminUsers__container, .AdminGroupFull__container, .AdminRasp__container, .content_admin {
    flex-direction: column !important;
    gap: 0 !important;
    width: 100% !important;
    margin-left: 0 !important;
    padding: 0 2px !important;
    box-sizing: border-box;
  }
  .Sidebar {
    display: none !important;
  }
  .content_admin {
    width: 100% !important;
    margin-left: 0 !important;
    padding: 0 2px !important;
    box-sizing: border-box;
  }
  .AdminSchedule-kanban, .AdminRasp .AdminSchedule-kanban {
    display: flex !important;
    flex-direction: row !important;
    gap: 8px !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 16px;
    margin-bottom: 0;
    width: 100%;
    max-width: 100vw;
  }
  .Schedule__column {
    min-width: 180px !important;
    max-width: 220px !important;
    width: 90vw !important;
  }
  .admin-sidebar, .Sidebar {
    display: none !important;
  }
  .content_admin {
    width: 100% !important;
    margin: 0 !important;
    padding-bottom: 70px !important;
  }
  .AdminGroups__container {
    flex-direction: column !important;
    padding: 0 !important;
  }
  .AdminGroups {
    padding: 0 0 70px 0 !important;
  }
  .admin-groups-table {
    min-width: 320px;
    font-size: 13px;
  }
  .admin-groups-modal-content {
    min-width: 90vw;
    max-width: 98vw;
    padding: 16px;
  }
  .AdminGroups {
    padding: 12px 8px 70px 8px !important;
    background: #f8f7fc;
    min-height: 100vh;
  }
  .AdminGroups__container {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
  }
  .content_admin {
    padding: 0 2px 70px 2px !important;
    width: 100% !important;
    margin: 0 !important;
    box-sizing: border-box;
  }
  .AdminHeader {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 10px;
  }
  .AdminHeader .title {
    font-size: 17px;
    margin-bottom: 2px;
  }
  .AdminHeader .buttton {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .AdminHeader .buttton button, .AdminHeader .buttton a, .AdminHeader .buttton .button {
    font-size: 14px !important;
    padding: 8px 14px !important;
    border-radius: 7px !important;
  }
  .admin-groups-search input {
    font-size: 14px;
    padding: 8px 10px;
    border-radius: 7px;
    margin-bottom: 8px;
  }
  .admin-groups-table {
    min-width: 0;
    font-size: 12px;
    border-radius: 10px;
    box-shadow: 0 1px 4px #ece9f7;
  }
  .admin-groups-table th, .admin-groups-table td {
    padding: 8px 6px;
    font-size: 12px;
  }
  .admin-groups-table th {
    font-size: 13px;
    background: #f3f0fa;
  }
  .admin-groups-table-row {
    border-radius: 8px;
    background: #fff;
    border-bottom: 1px solid #ece9f7;
  }
  .admin-groups-table-row:last-child {
    border-bottom: none;
  }
  .admin-groups-btn {
    font-size: 12px;
    padding: 5px 10px;
    border-radius: 7px;
    min-width: 0;
    margin: 0 auto;
    display: block;
  }
  .admin-groups-btn-secondary {
    background: #f8f7fc;
    color: #6c3be4;
    border: 1px solid #ece9f7;
  }
  .admin-groups-btn-secondary:hover {
    background: #ece9f7;
    color: #4c20bb;
  }
  .admin-groups-modal-content {
    min-width: 96vw;
    max-width: 99vw;
    padding: 10px;
    border-radius: 10px;
  }
  .admin-groups-modal-title {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .admin-groups-modal-field input {
    font-size: 13px;
    padding: 7px 8px;
    border-radius: 7px;
  }
  .admin-groups-modal-btn {
    font-size: 13px;
    padding: 6px 10px;
    border-radius: 7px;
  }
  .admin-groups-modal-btn-primary {
    font-size: 13px;
    padding: 6px 10px;
    border-radius: 7px;
  }
  nav {
    height: 52px !important;
    min-height: 52px !important;
    max-height: 52px !important;
  }
  nav .MuiBottomNavigationAction-label, nav span {
    font-size: 11px !important;
  }
  nav button {
    font-size: 20px !important;
    padding: 0 2px !important;
  }
}
@media (max-width: 600px) {
  .AdminUsers {
    padding: 12px 8px 70px 8px !important;
    background: #f8f7fc;
    min-height: 100vh;
  }
  .AdminUsers__container {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
  }
  .content_admin {
    padding: 0 2px 70px 2px !important;
    width: 100% !important;
    margin: 0 !important;
    box-sizing: border-box;
  }
  .AdminHeader {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 10px;
  }
  .AdminHeader .title {
    font-size: 17px;
    margin-bottom: 2px;
  }
  .AdminHeader .buttton {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .AdminHeader .buttton button, .AdminHeader .buttton a, .AdminHeader .buttton .button {
    font-size: 14px !important;
    padding: 8px 14px !important;
    border-radius: 7px !important;
  }
  .search input {
    font-size: 14px;
    width: 100% !important;
    padding: 8px 10px;
    border-radius: 7px;
    margin-bottom: 8px;
  }
  .admin-users-table {
    min-width: 0;
    font-size: 12px;
    border-radius: 10px;
    box-shadow: 0 1px 4px #ece9f7;
  }
  .admin-users-table th, .admin-users-table td {
    padding: 8px 6px;
    font-size: 12px;
  }
  .admin-users-table th {
    font-size: 13px;
    background: #f3f0fa;
  }
  .admin-users-table tr {
    border-radius: 8px;
    background: #fff;
    border-bottom: 1px solid #ece9f7;
  }
  .admin-users-table tr:last-child {
    border-bottom: none;
  }
  .admin-users-schedule-btn {
    font-size: 12px;
    padding: 5px 10px;
    border-radius: 7px;
    min-width: 0;
    margin: 0 auto;
    display: block;
  }
  .admin-users-modal-content {
    min-width: 96vw;
    max-width: 99vw;
    padding: 10px;
    border-radius: 10px;
  }
  .admin-users-modal-title {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .admin-users-modal-field input, .admin-users-modal-field select {
    font-size: 13px;
    padding: 7px 8px;
    border-radius: 7px;
  }
  .admin-users-modal-btn {
    font-size: 13px;
    padding: 6px 10px;
    border-radius: 7px;
  }
  .admin-users-modal-btn-primary {
    font-size: 13px;
    padding: 6px 10px;
    border-radius: 7px;
  }
  .admin-users-modal-overlay {
    align-items: flex-start;
    padding-top: 30px;
  }
  .admin-users-table-wrapper {
    margin-top: 16px;
  }
  .search {
    flex-direction: column !important;
    gap: 8px !important;
    align-items: stretch !important;
    margin-bottom: 10px !important;
    position: static !important;
  }
  .search button {
    font-size: 13px;
    padding: 7px 10px;
    border-radius: 7px;
    width: 100%;
    margin-top: 4px;
  }
  .search select {
    font-size: 13px;
    padding: 7px 8px;
    border-radius: 7px;
    margin-bottom: 8px;
  }
  .search div[style*="position: absolute"] {
    position: static !important;
    min-width: 0 !important;
    box-shadow: 0 1px 4px #ece9f7 !important;
    border-radius: 10px !important;
    padding: 10px !important;
    margin-top: 8px !important;
  }
}
@media (max-width: 600px) {
  .AdminRasp {
    padding: 12px 8px 70px 8px !important;
    background: #f8f7fc;
    min-height: 100vh;
  }
  .AdminRasp__container {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
  }
  .content_admin {
    padding: 0 2px 70px 2px !important;
    width: 100% !important;
    margin: 0 !important;
    box-sizing: border-box;
  }
  .AdminHeader {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 10px;
  }
  .AdminHeader .title {
    font-size: 17px;
    margin-bottom: 2px;
  }
  .AdminHeader .buttton {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .AdminHeader .buttton button, .AdminHeader .buttton a, .AdminHeader .buttton .button {
    font-size: 14px !important;
    padding: 8px 14px !important;
    border-radius: 7px !important;
  }
  .adminschedule-header {
    flex-direction: column !important;
    gap: 8px !important;
    align-items: stretch !important;
    margin-bottom: 10px !important;
  }
  .adminschedule-header-label {
    font-size: 13px !important;
  }
  .adminschedule-select {
    font-size: 13px !important;
    padding: 7px 8px !important;
    border-radius: 7px !important;
    margin-bottom: 8px !important;
  }
  .AdminSchedule-kanban {
    flex-direction: row !important;
    gap: 8px !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 16px;
    margin-bottom: 0;
    width: 100%;
    max-width: 100vw;
  }
  .Schedule__column {
    min-width: 160px !important;
    max-width: 220px !important;
    width: 90vw !important;
    font-size: 12px !important;
  }
  .ScheduleBlock, .ScheduleBlock.filled, .ScheduleBlock.empty {
    width: 100% !important;
    padding: 10px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
    margin-bottom: 10px !important;
  }
  .scheduleblock-time, .scheduleblock-group, .scheduleblock-subject, .scheduleblock-comment {
    font-size: 12px !important;
  }
  .scheduleblock-actions button {
    font-size: 12px !important;
    padding: 5px 10px !important;
    border-radius: 7px !important;
    margin-bottom: 4px !important;
  }
  .add-slot-btn {
    font-size: 22px !important;
    border-radius: 7px !important;
    padding: 0 6px !important;
  }
  .scheduleblock-edit-btn, .scheduleblock-details-btn, .scheduleblock-delete-btn {
    font-size: 12px !important;
    padding: 5px 10px !important;
    border-radius: 7px !important;
  }
  .scheduleblock-details-btn {
    margin-top: 4px !important;
  }
  .scheduleblock-delete-btn {
    margin-top: 4px !important;
  }
  .admin-user-back-btn {
    font-size: 13px !important;
    padding: 6px 10px !important;
    border-radius: 7px !important;
    margin-bottom: 10px !important;
  }
  .admin-user-title {
    font-size: 16px !important;
    margin-bottom: 10px !important;
  }
  .admin-user-full-info {
    font-size: 13px !important;
    padding: 12px 10px !important;
    border-radius: 8px !important;
    margin-top: 10px !important;
    max-width: 98vw !important;
  }
  .admin-user-full-wrapper {
    padding-top: 10px !important;
  }
  .admin-user-schedule-wrapper {
    padding-top: 10px !important;
  }
  .admin-user-back-btn {
    margin-bottom: 10px !important;
  }
}
@media (max-width: 600px) {
  .AdminSchedule-kanban, .AdminRasp .AdminSchedule-kanban {
    box-shadow: none !important;
    border: none !important;
    background: none !important;
  }
  .Schedule__column {
    box-shadow: none !important;
    border: none !important;
    background: none !important;
  }
  .Schedule__column:not(:last-child) {
    border-right: none !important;
    box-shadow: none !important;
  }
}
@media (max-width: 600px) {
  .AdminNews {
    padding: 12px 8px 70px 8px !important;
    background: #f8f7fc;
    min-height: 100vh;
  }
  .AdminNews__container {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
  }
  .content_admin {
    padding: 0 2px 70px 2px !important;
    width: 100% !important;
    margin: 0 !important;
    box-sizing: border-box;
  }
  .content_admin > div[style*="display: flex"][style*="margin-bottom: 24px"] {
    flex-direction: column !important;
    gap: 8px !important;
    align-items: stretch !important;
    margin-bottom: 10px !important;
  }
  .content_admin h2 {
    font-size: 18px !important;
    margin-bottom: 4px !important;
  }
  .content_admin button {
    font-size: 13px !important;
    padding: 8px 14px !important;
    border-radius: 7px !important;
  }
  .content_admin ul {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
  }
  .content_admin li {
    flex-direction: column !important;
    gap: 10px !important;
    padding: 14px !important;
    border-radius: 10px !important;
    margin-bottom: 16px !important;
    box-shadow: 0 1px 4px #ece9f7 !important;
  }
  .content_admin .NewsBlock, .content_admin li {
    font-size: 13px !important;
  }
  .content_admin .NewsBlock .title, .content_admin li .title {
    font-size: 15px !important;
    margin-bottom: 4px !important;
  }
  .content_admin .NewsBlock .text, .content_admin li .text {
    font-size: 13px !important;
    margin-bottom: 4px !important;
    -webkit-line-clamp: 4 !important;
  }
  .content_admin .NewsBlock img, .content_admin li img {
    width: 28px !important;
    height: auto !important;
    min-width: 0 !important;
    max-width: 100% !important;
    border-radius: 8px !important;
    margin-bottom: 8px !important;
  }
  .content_admin .NewsBlock .date, .content_admin li .date {
    font-size: 11px !important;
    margin-bottom: 2px !important;
  }
  .content_admin .NewsBlock button, .content_admin li button {
    font-size: 12px !important;
    padding: 7px 10px !important;
    border-radius: 7px !important;
    margin-bottom: 4px !important;
  }
  .modal-overlay, .admin-news-modal-overlay {
    align-items: flex-start !important;
    padding-top: 30px !important;
  }
  .modal-content, .admin-news-modal-content {
    min-width: 96vw !important;
    max-width: 99vw !important;
    padding: 10px !important;
    border-radius: 10px !important;
  }
  .modal-content h3, .admin-news-modal-content h3 {
    font-size: 16px !important;
    margin-bottom: 10px !important;
  }
  .modal-content input, .modal-content textarea, .admin-news-modal-content input, .admin-news-modal-content textarea {
    font-size: 13px !important;
    padding: 7px 8px !important;
    border-radius: 7px !important;
  }
  .modal-content button, .admin-news-modal-content button {
    font-size: 13px !important;
    padding: 6px 10px !important;
    border-radius: 7px !important;
  }
}
@media (max-width: 600px) {
  .modal-overlay, .admin-rasp-modal-overlay {
    align-items: flex-start !important;
    padding-top: 30px !important;
  }
  .modal-content, .admin-rasp-modal-content {
    min-width: 96vw !important;
    max-width: 99vw !important;
    padding: 10px !important;
    border-radius: 10px !important;
    box-shadow: 0 1px 8px #ece9f7 !important;
  }
  .modal-content h3, .admin-rasp-modal-content h3 {
    font-size: 16px !important;
    margin-bottom: 10px !important;
  }
  .modal-content label, .admin-rasp-modal-content label {
    font-size: 13px !important;
    margin-bottom: 2px !important;
  }
  .modal-content input, .modal-content select, .modal-content textarea,
  .admin-rasp-modal-content input, .admin-rasp-modal-content select, .admin-rasp-modal-content textarea {
    font-size: 13px !important;
    padding: 7px 8px !important;
    border-radius: 7px !important;
    margin-bottom: 8px !important;
  }
  .modal-content button, .admin-rasp-modal-content button {
    font-size: 13px !important;
    padding: 6px 10px !important;
    border-radius: 7px !important;
    margin-bottom: 4px !important;
  }
  .modal-content .modal-actions, .admin-rasp-modal-content .modal-actions {
    gap: 8px !important;
  }
}
.admin-slot-details-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-slot-details-modal-content {
  background: #fff;
  border-radius: 16px;
  padding: 24px 18px;
  min-width: 320px;
  max-width: 420px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 2px 16px #ece9f7;
  display: flex;
  flex-direction: column;
}

.admin-slot-details-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.admin-slot-details-modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: #6c3be4;
}

.admin-slot-details-modal-close {
  background: none;
  border: none;
  font-size: 22px;
  color: #6c3be4;
  cursor: pointer;
  font-weight: 700;
}

.admin-slot-details-modal-info {
  margin-bottom: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #ece9f7;
}

.admin-slot-details-modal-time {
  font-weight: 600;
  font-size: 16px;
  color: #222;
  margin-bottom: 2px;
}

.admin-slot-details-modal-subject {
  font-weight: 500;
  color: #6c3be4;
  font-size: 15px;
}

.admin-slot-details-modal-meta {
  margin-bottom: 8px;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  font-size: 14px;
}

.admin-slot-details-modal-comment {
  margin-bottom: 12px;
  font-size: 13px;
  color: #555;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 7px 10px;
}

.admin-slot-details-modal-files-title {
  margin: 14px 0 8px;
  font-weight: 600;
  font-size: 15px;
  color: #222;
}

.admin-slot-details-modal-files-list-wrapper {
  background: #f8f7fc;
  border-radius: 8px;
  padding: 8px 6px;
  margin-bottom: 8px;
  max-height: 220px;
  overflow-y: auto;
}

.admin-slot-details-modal-user-files {
  margin-bottom: 14px;
  background: #f3f0fa;
  border-radius: 10px;
  padding: 8px;
}

.admin-slot-details-modal-user {
  font-weight: 600;
  color: #6c3be4;
  font-size: 13px;
  margin-bottom: 6px;
}

.admin-slot-details-modal-file-list {
  padding: 0;
  list-style: none;
  margin: 0;
}

.admin-slot-details-modal-file-item {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border-radius: 7px;
  padding: 6px;
  box-shadow: 0 1px 4px #ece9f7;
}

.admin-slot-details-modal-file-img {
  width: 28px;
  height: 28px;
  object-fit: cover;
  border-radius: 5px;
  box-shadow: 0 1px 3px #ddd;
}

.admin-slot-details-modal-file-icon {
  font-size: 18px;
  margin-right: 2px;
}

.admin-slot-details-modal-file-info {
  flex: 1 1;
  min-width: 0;
}

.admin-slot-details-modal-file-link {
  color: #6c3be4;
  text-decoration: underline;
  font-size: 13px;
  word-break: break-all;
  font-weight: 500;
}

.admin-slot-details-modal-file-date {
  color: #888;
  font-size: 11px;
  margin-top: 2px;
}

.admin-slot-details-modal-file-comment {
  color: #6c3be4;
  font-size: 12px;
  margin-top: 2px;
}

.admin-slot-details-modal-file-download {
  background: #6c3be4;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 5px 10px;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
  margin-left: 6px;
}

.admin-slot-details-modal-no-files {
  color: #888;
  font-size: 13px;
  margin-left: 8px;
}

@media (max-width: 600px) {
  .admin-slot-details-modal-content {
    min-width: 96vw !important;
    max-width: 99vw !important;
    padding: 8px 2px !important;
    border-radius: 10px !important;
  }
  .admin-slot-details-modal-header h2 {
    font-size: 16px !important;
  }
  .admin-slot-details-modal-files-list-wrapper {
    max-height: 160px !important;
    padding: 4px 2px !important;
  }
  .admin-slot-details-modal-file-img {
    width: 22px !important;
    height: 22px !important;
    border-radius: 4px !important;
  }
  .admin-slot-details-modal-file-link {
    font-size: 12px !important;
  }
  .admin-slot-details-modal-file-download {
    font-size: 11px !important;
    padding: 4px 7px !important;
    border-radius: 6px !important;
  }
}
@media (max-width: 600px) {
  .AdminUserSchedule {
    padding: 12px 8px 70px 8px !important;
    background: #f8f7fc;
    min-height: 100vh;
  }
  .AdminUserSchedule__container {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
  }
  .content_admin.admin-user-schedule-wrapper {
    padding: 0 2px 70px 2px !important;
    width: 100% !important;
    margin: 0 !important;
    box-sizing: border-box;
  }
  .admin-user-back-btn {
    font-size: 13px !important;
    padding: 6px 10px !important;
    border-radius: 7px !important;
    margin-bottom: 10px !important;
  }
  .admin-user-title {
    font-size: 16px !important;
    margin-bottom: 10px !important;
    word-break: break-word;
  }
  .AdminSchedule-kanban {
    flex-direction: row !important;
    gap: 8px !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 16px;
    margin-bottom: 0;
    width: 100%;
    max-width: 100vw;
  }
  .Schedule__column {
    min-width: 160px !important;
    max-width: 220px !important;
    width: 90vw !important;
    font-size: 12px !important;
  }
  .ScheduleBlock, .ScheduleBlock.filled, .ScheduleBlock.empty {
    width: 100% !important;
    padding: 10px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
    margin-bottom: 10px !important;
  }
}
@media (max-width: 900px) {
  .AdminUserFull__container {
    flex-direction: column !important;
    padding: 0 !important;
  }
  .admin-user-full-wrapper {
    flex-direction: column !important;
    gap: 0 !important;
    margin: 0 !important;
    padding: 0 0 60px 0 !important;
  }
  .admin-user-full-info {
    padding: 16px 10px 18px 10px !important;
    background: #fafaff;
    border-radius: 12px;
    box-shadow: 0 1px 8px #ece9f7;
    margin-bottom: 18px !important;
    font-size: 15px !important;
  }
  .admin-user-title {
    font-size: 20px !important;
    margin-bottom: 12px !important;
    text-align: left !important;
  }
  .admin-user-back-btn {
    margin: 10px 0 0 0 !important;
    font-size: 15px !important;
    padding: 7px 18px !important;
  }
  .admin-user-full-info input,
  .admin-user-full-info button {
    font-size: 15px !important;
    padding: 7px 12px !important;
    min-width: 0 !important;
    width: 100%;
    margin-bottom: 8px;
  }
  .admin-user-full-info label {
    font-size: 15px !important;
    min-width: 60px !important;
  }
  .admin-user-full-info ul {
    max-width: 100% !important;
    overflow-x: auto;
  }
  .admin-user-full-info li {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
    padding: 10px !important;
    font-size: 14px !important;
  }
  .admin-user-full-info h3 {
    font-size: 17px !important;
    margin-bottom: 10px !important;
  }
  .admin-user-full-info a {
    font-size: 15px !important;
    word-break: break-all;
  }
  .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {
    margin-bottom: 8px !important;
  }
  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {
    padding: 0 !important;
  }
}
.admin-user-full-flex {
  display: flex;
  gap: 40px;
  align-items: flex-start;
  margin-top: 24px;
}

@media (max-width: 900px) {
  .admin-user-full-flex {
    flex-direction: column !important;
    gap: 0 !important;
    margin-top: 10px !important;
  }
  .admin-user-full-info {
    margin-bottom: 16px !important;
  }
  .content_admin .admin-user-full-wrapper > .admin-user-full-flex > div {
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  .content_admin .admin-user-full-wrapper > .admin-user-full-flex > div:last-child {
    margin-left: 0 !important;
    margin-top: 18px !important;
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
    padding: 18px 8px !important;
    box-sizing: border-box;
  }
}
.admin-user-full-name-row {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 6px;
}

@media (max-width: 900px) {
  .admin-user-full-name-row {
    flex-direction: column !important;
    gap: 8px !important;
    align-items: stretch !important;
    margin-top: 6px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,sDAAA;AACA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AAGF;;AADA;EACE,qBAAA;AAIF;;AAFA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EAAS,QAAA;EACT,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gDAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAMF;;AAJA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAOF;;AALA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAQF;;AANA;EACE,mBAAA;AASF;;AAPA;EACE,WAAA;EACA,YAAA;AAUF;;AAPA,4CAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AAUF;;AARA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAWF;;AATA;EACE,gBAAA;EACA,yCAAA;AAYF;;AANA;EACI,SAAA;EACA,UAAA;EACA,uBAAA;AASJ;;AANA;EACI,uBAAA;AASJ;;AANA;EACI,iBAAA;EACA,gBAAA;AASJ;;AANA;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AASJ;AAPI;EACI,yBAAA;EACA,aAAA;AASR;;AALA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBApCY;EAqCZ,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;AAQJ;AANI;EACI,2CAAA;AAQR;;AAJA;EACI,aAAA;EACA,mBAlDY;EAmDZ,YAAA;EACA,eAAA;AAOJ;AALI;EACI,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAOR;AAHQ;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAKZ;AAHY;EACI,WAAA;EACA,qBAAA;AAKhB;AAHgB;EACI,gBAAA;AAKpB;AACI;EACI,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AACR;AACQ;EACI,aAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AACZ;;AAIA;EACI,WAAA;EACA,mBArGY;EAsGZ,iBAAA;AADJ;AAGI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AADR;AAGQ;EACI,eAAA;EACA,WAAA;EACA,gBAAA;AADZ;AAKY;EACI,aAAA;EACA,SAAA;AAHhB;AAKgB;EACI,gBAAA;AAHpB;AAKoB;EACI,WAAA;EACA,qBAAA;AAHxB;AAKwB;EACI,gCAAA;AAH5B;;AAYA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AATJ;AAWI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;AATR;AAWQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;AATZ;AAYQ;EACI,gBAAA;AAVZ;AAaQ;EACI,kBAAA;AAXZ;AAaY;EACI,WAAA;EACA,mBAAA;AAXhB;AAcY;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;AAZhB;AAcgB;EACA,WAAA;AAZhB;;AAsBQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAnBZ;AAqBY;EACI,kBAAA;EACA,cAtMA;EAuMA,gBAAA;EACA,oBAAA;EACA,gCAAA;AAnBhB;AAuBQ;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AArBZ;AAwBY;EACI,eAAA;AAtBhB;AAwBgB;EACI,gBAAA;AAtBpB;AA0BY;EACI,gBAAA;AAxBhB;;AAgCI;EACI,aAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AA7BR;AA+BQ;EACI,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,kBAAA;AA7BZ;AAgCgB;EACI,WAAA;EACA,aAAA;EACA,iBAAA;AA9BpB;AAkCY;EACI,aAAA;EACA,sBAAA;AAhChB;AAkCgB;EACI,eAAA;EACA,YAAA;EACA,kBAAA;AAhCpB;AAmCgB;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;AAjCpB;AAoCgB;EACI,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAlCpB;;AA0CI;EACI,aAAA;EACA,iBAAA;EACA,SAAA;AAvCR;AAyCQ;EACI,UAAA;AAvCZ;AA0CgB;EACI,WAAA;EACA,kBAAA;AAxCpB;AA6CQ;EACI,UAAA;AA3CZ;AA6CY;EACI,eAAA;EACA,gBAAA;AA3ChB;AA8CY;EACI,gBAAA;AA5ChB;AA+CY;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AA7ChB;;AAmDA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAhDJ;AAkDI;EACI,eAAA;EACA,gBAAA;AAhDR;;AAoDA;EACI,aAAA;EACA,SAAA;AAjDJ;AAmDI;EACI,gBAAA;EACA,mBAAA;AAjDR;AAoDI;EACI,aAAA;EACA,8BAAA;AAlDR;AAoDQ;EACI,eAAA;EACA,gBAAA;AAlDZ;AAqDQ;EACI,YAAA;AAnDZ;AAsDQ;EACI,YAAA;AApDZ;AAuDQ;EACI,YAAA;AArDZ;AAwDQ;EACI,YAAA;AAtDZ;AA0DI;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AAxDR;AA0DQ;EACI,YAAA;AAxDZ;AA2DQ;EACI,YAAA;AAzDZ;AA4DQ;EACI,YAAA;AA1DZ;AA4DY;EACI,eAAA;EACA,YAAA;AA1DhB;AA8DQ;EACI,YAAA;AA5DZ;AA8DY;EACI,eAAA;EACA,YAAA;AA5DhB;;AAkEA;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;EAEJ;;SAAA;EAIA;;SAAA;AA/DA;;AAqEI;EACI,aAAA;EACA,SAAA;AAlER;AAoEQ;EACI,gBAAA;AAlEZ;AAqEQ;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AAnEZ;AAqEY;EACI,eAAA;EACA,gBAAA;AAnEhB;AAsEY;EACI,YAAA;AApEhB;AAuEY;EACI,WAAA;AArEhB;AAwEY;;;EAGI,YAAA;AAtEhB;AA0EQ;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AAxEZ;AA0EY;EACI,YAAA;EACA,eAAA;AAxEhB;AA2EY;EACI,WAAA;EACA,eAAA;AAzEhB;AA4EY;;;EAGI,YAAA;AA1EhB;AA6EY;EACI,eAAA;EACA,YAAA;AA3EhB;;AAiFA;EACE,aAAA;EACA,mBAAA;AA9EF;;AAgFA;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA7EF;;AA+EA;;;EAGE,gBAAA;EACA,gBAAA;EACA,kBAAA;AA5EF;;AA+EA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AA5EF;;AA8EA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AA3EF;;AA6EA;EACE,mBAAA;AA1EF;;AA4EA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzEF;;AA2EA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAxEF;;AA0EA;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,uCAAA;AAvEF;;AAyEA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;AAtEF;;AAwEA;EACE,mBAAA;AArEF;;AAuEA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AApEF;;AAsEA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAnEF;;AAqEA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAlEF;;AAoEA;EACE,kBAAA;AAjEF;;AAmEA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAhEF;;AAkEA;EACE,gBAAA;EACA,kBAAA;AA/DF;;AAiEA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AA9DF;;AAgEA;EACE,eAAA;EACA,WAAA;EACA,eAAA;AA7DF;;AA+DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA5DF;;AA8DA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AA3DF;;AA6DA;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,uCAAA;AA1DF;;AA4DA;EACE,mBAAA;EACA,WAAA;AAzDF;;AA2DA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AAxDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,iBAAA;AAvDF;;AAyDA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AAtDF;;AAwDA;EACE,mBAAA;AArDF;;AAuDA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AApDF;;AAuDA;EACE,gBAAA;EACA,gBAAA;AApDF;;AAsDA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAnDF;;AAqDA;EACE,kBAAA;EACA,gBAAA;AAlDF;;AAoDA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AAjDF;;AAmDA;EACE,gCAAA;AAhDF;;AAkDA;EACE,mBAAA;AA/CF;;AAiDA;EACE,sBAAA;AA9CF;;AAiDA;EACE,iBAAA;AA9CF;;AAgDA;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;AA7CF;;AAgDA,kCAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA7CF;;AA+CA;EACE,gBAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;AA5CF;;AA8CA;EACE,qBAAA;AA3CF;;AA6CA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gDAAA;EACA,aAAA;EACA,YAAA;AA1CF;;AA4CA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAzCF;;AA2CA;EACE,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAxCF;;AA0CA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAvCF;;AAyCA;EACE,mBAAA;EACA,WAAA;EACA,yBAAA;AAtCF;;AAwCA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AArCF;;AAuCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AApCF;;AAsCA;EACE,mBAAA;AAnCF;;AAqCA;EACE,WAAA;EACA,YAAA;AAlCF;;AAoCA;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AAjCF;;AAmCA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AAhCF;;AAkCA;EACE,gBAAA;EACA,gBAAA;AA/BF;;AAiCA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AA9BF;;AAgCA;EACE,kBAAA;EACA,gBAAA;AA7BF;;AA+BA;EACE,kBAAA;AA5BF;;AA8BA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AA3BF;;AA6BA;EACE,gBAAA;EACA,kBAAA;EACA,2BAAA;AA1BF;;AA4BA;EACE,mBAAA;AAzBF;;AA2BA;EACE,qBAAA;AAxBF;;AA0BA;EACE,WAAA;AAvBF;;AAyBA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAtBF;;AAwBA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AArBF;;AAuBA;EACE,gBAAA;EACA,eAAA;AApBF;;AAsBA;EACE,kBAAA;EACA,eAAA;AAnBF;;AAqBA;EACE,kBAAA;AAlBF;;AAoBA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;AAjBF;;AAmBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAkBA;EACE,mBAAA;EACA,cAAA;AAfF;;AAkBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AAfF;;AAiBA;EACE,gBAAA;AAdF;;AAgBA;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;AAbF;;AAeA;EACE,aAAA;EACA,SAAA;AAZF;;AAcA;EACE,SAAA;AAXF;;AAaA;EACE,kBAAA;EACA,mBAAA;AAVF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AATF;;AAWA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AARF;;AAUA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAPF;;AASA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AANF;;AAUA;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;AAPF;;AASA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AANF;;AAQA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;AALF;;AAOA;EACE,gBAAA;EACA,gBAAA;AAJF;;AAMA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AAHF;;AAKA;EACE,kBAAA;EACA,gBAAA;AAFF;;AAIA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AADF;;AAGA;EACE,mBAAA;EACA,kBAAA;EACA,2BAAA;AAAF;;AAEA;EACE,mBAAA;AACF;;AACA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AAEF;;AAAA;EACE,gBAAA;EACA,eAAA;AAGF;;AADA;EACE,kBAAA;EACA,eAAA;AAIF;;AAFA;EACE,kBAAA;AAKF;;AAHA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;AAMF;;AAJA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAOF;;AALA;EACE,mBAAA;EACA,cAAA;AAQF;;AALA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAQF;;AANA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,8BAAA;AASF;;AAPA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAUF;;AARA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;AAWF;;AATA;EACE,kBAAA;EACA,gBAAA;AAYF;;AAVA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAaF;;AAXA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AAcF;;AAZA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAeF;;AAbA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAgBF;;AAdA;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,uCAAA;AAiBF;;AAfA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;AAkBF;;AAhBA;EACE,mBAAA;AAmBF;;AAfA;EACE;IACE,eAAA;IACA,SAAA;IACA,2BAAA;EAkBF;EAhBA;IACE,UAAA;IACA,gBAAA;IACA,eAAA;EAkBF;EAhBA;IACE,kBAAA;IACA,mBAAA;EAkBF;EAhBA;IACE,iCAAA;IACA,iBAAA;IACA,sBAAA;IACA,yBAAA;IACA,yBAAA;IACA,sBAAA;EAkBF;EAhBA;IACE,2BAAA;IACA,sBAAA;IACA,uBAAA;IACA,uBAAA;IACA,2BAAA;IACA,mBAAA;EAkBF;EAhBA;IACE,sBAAA;IACA,yBAAA;IACA,yBAAA;IACA,sBAAA;EAkBF;EAhBA;IACE,wBAAA;IACA,8BAAA;IACA,oBAAA;IACA,2BAAA;IACA,iCAAA;IACA,oBAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;EAkBF;EAhBA;IACE,2BAAA;IACA,2BAAA;IACA,sBAAA;EAkBF;EAhBA;IACE,iCAAA;IACA,iBAAA;IACA,sBAAA;IACA,yBAAA;IACA,yBAAA;IACA,sBAAA;EAkBF;EAhBA;IACE,sBAAA;IACA,yBAAA;IACA,yBAAA;IACA,sBAAA;EAkBF;EAhBA;IACE,wBAAA;EAkBF;EAhBA;IACE,8BAAA;EAkBF;EAhBA;IACE,gBAAA;IACA,eAAA;EAkBF;EAhBA;IACE,eAAA;IACA,eAAA;IACA,aAAA;EAkBF;EAhBA;IACE,wBAAA;EAkBF;AACF;AAhBA;EACE;IACE,uBAAA;IACA,iBAAA;IACA,YAAA;EAkBF;EAhBA;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,kDAAA;EAkBF;EAhBA;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;EAkBF;EAhBA;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,mBAAA;EAkBF;EAhBA;IACE,eAAA;IACA,YAAA;EAkBF;EAhBA;IACE,iBAAA;IACA,kBAAA;IACA,oBAAA;IACA,sBAAA;EAkBF;EAhBA;IACE,iCAAA;IACA,iBAAA;EAkBF;EAhBA;IACE,sBAAA;IACA,0BAAA;IACA,qBAAA;EAkBF;EAhBA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;EAkBF;EAhBA;IACE,eAAA;IACA,eAAA;EAkBF;EAhBA;IACE,iCAAA;IACA,iBAAA;IACA,sBAAA;IACA,yBAAA;IACA,yBAAA;IACA,sBAAA;EAkBF;EAhBA;IACE,wBAAA;EAkBF;EAhBA;IACE,sBAAA;IACA,yBAAA;IACA,yBAAA;IACA,sBAAA;EAkBF;EAhBA;IACE,wBAAA;IACA,8BAAA;IACA,mBAAA;IACA,2BAAA;IACA,iCAAA;IACA,oBAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;EAkBF;EAhBA;IACE,2BAAA;IACA,2BAAA;IACA,sBAAA;EAkBF;EAhBA;IACE,wBAAA;EAkBF;EAhBA;IACE,sBAAA;IACA,oBAAA;IACA,+BAAA;EAkBF;EAhBA;IACE,iCAAA;IACA,qBAAA;EAkBF;EAhBA;IACE,8BAAA;EAkBF;EAhBA;IACE,gBAAA;IACA,eAAA;EAkBF;EAhBA;IACE,eAAA;IACA,eAAA;IACA,aAAA;EAkBF;EAhBA;IACE,qCAAA;IACA,mBAAA;IACA,iBAAA;EAkBF;EAhBA;IACE,qBAAA;IACA,oBAAA;IACA,sBAAA;EAkBF;EAhBA;IACE,kCAAA;IACA,sBAAA;IACA,oBAAA;IACA,sBAAA;EAkBF;EAhBA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,mBAAA;EAkBF;EAjBE;IACE,eAAA;IACA,kBAAA;EAmBJ;EAjBE;IACE,WAAA;IACA,aAAA;IACA,yBAAA;EAmBJ;EAlBI;IACE,0BAAA;IACA,4BAAA;IACA,6BAAA;EAoBN;EAhBA;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,kBAAA;EAkBF;EAhBA;IACE,YAAA;IACA,eAAA;IACA,mBAAA;IACA,6BAAA;EAkBF;EAhBA;IACE,gBAAA;IACA,eAAA;EAkBF;EAhBA;IACE,eAAA;IACA,mBAAA;EAkBF;EAhBA;IACE,kBAAA;IACA,gBAAA;IACA,gCAAA;EAkBF;EAhBA;IACE,mBAAA;EAkBF;EAhBA;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,YAAA;IACA,cAAA;IACA,cAAA;EAkBF;EAhBA;IACE,mBAAA;IACA,cAAA;IACA,yBAAA;EAkBF;EAhBA;IACE,mBAAA;IACA,cAAA;EAkBF;EAhBA;IACE,eAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;EAkBF;EAhBA;IACE,eAAA;IACA,mBAAA;EAkBF;EAhBA;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;EAkBF;EAhBA;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;EAkBF;EAhBA;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;EAkBF;EAfA;IACE,uBAAA;IACA,2BAAA;IACA,2BAAA;EAiBF;EAhBE;IACE,0BAAA;EAkBJ;EAhBE;IACE,0BAAA;IACA,yBAAA;EAkBJ;AACF;AAfA;EACE;IACE,qCAAA;IACA,mBAAA;IACA,iBAAA;EAiBF;EAfA;IACE,qBAAA;IACA,oBAAA;IACA,sBAAA;EAiBF;EAfA;IACE,kCAAA;IACA,sBAAA;IACA,oBAAA;IACA,sBAAA;EAiBF;EAfA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,mBAAA;EAiBF;EAhBE;IACE,eAAA;IACA,kBAAA;EAkBJ;EAhBE;IACE,WAAA;IACA,aAAA;IACA,yBAAA;EAkBJ;EAjBI;IACE,0BAAA;IACA,4BAAA;IACA,6BAAA;EAmBN;EAfA;IACE,eAAA;IACA,sBAAA;IACA,iBAAA;IACA,kBAAA;IACA,kBAAA;EAiBF;EAfA;IACE,YAAA;IACA,eAAA;IACA,mBAAA;IACA,6BAAA;EAiBF;EAfA;IACE,gBAAA;IACA,eAAA;EAiBF;EAfA;IACE,eAAA;IACA,mBAAA;EAiBF;EAfA;IACE,kBAAA;IACA,gBAAA;IACA,gCAAA;EAiBF;EAfA;IACE,mBAAA;EAiBF;EAfA;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,YAAA;IACA,cAAA;IACA,cAAA;EAiBF;EAfA;IACE,eAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;EAiBF;EAfA;IACE,eAAA;IACA,mBAAA;EAiBF;EAfA;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;EAiBF;EAfA;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;EAiBF;EAfA;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;EAiBF;EAfA;IACE,uBAAA;IACA,iBAAA;EAiBF;EAfA;IACE,gBAAA;EAiBF;EAfA;IACE,iCAAA;IACA,mBAAA;IACA,+BAAA;IACA,8BAAA;IACA,2BAAA;EAiBF;EAfA;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;EAiBF;EAfA;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,kBAAA;EAiBF;EAfA;IACE,2BAAA;IACA,uBAAA;IACA,wCAAA;IACA,8BAAA;IACA,wBAAA;IACA,0BAAA;EAiBF;AACF;AAfA;EACE;IACE,qCAAA;IACA,mBAAA;IACA,iBAAA;EAiBF;EAfA;IACE,qBAAA;IACA,oBAAA;IACA,sBAAA;EAiBF;EAfA;IACE,kCAAA;IACA,sBAAA;IACA,oBAAA;IACA,sBAAA;EAiBF;EAfA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,mBAAA;EAiBF;EAhBE;IACE,eAAA;IACA,kBAAA;EAkBJ;EAhBE;IACE,WAAA;IACA,aAAA;IACA,yBAAA;EAkBJ;EAjBI;IACE,0BAAA;IACA,4BAAA;IACA,6BAAA;EAmBN;EAfA;IACE,iCAAA;IACA,mBAAA;IACA,+BAAA;IACA,8BAAA;EAiBF;EAfA;IACE,0BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,2BAAA;IACA,6BAAA;IACA,6BAAA;EAiBF;EAfA;IACE,8BAAA;IACA,mBAAA;IACA,2BAAA;IACA,iCAAA;IACA,oBAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;EAiBF;EAfA;IACE,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,0BAAA;EAiBF;EAfA;IACE,sBAAA;IACA,wBAAA;IACA,0BAAA;IACA,6BAAA;IACA,8BAAA;EAiBF;EAfA;IACE,0BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,4BAAA;IACA,6BAAA;IACA,6BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,6BAAA;IACA,yBAAA;EAiBF;EAfA;IACE,0BAAA;IACA,4BAAA;IACA,6BAAA;EAiBF;EAfA;IACE,0BAAA;EAiBF;EAfA;IACE,0BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,4BAAA;IACA,6BAAA;IACA,8BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,8BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,6BAAA;IACA,6BAAA;IACA,2BAAA;IACA,0BAAA;EAiBF;EAfA;IACE,4BAAA;EAiBF;EAfA;IACE,4BAAA;EAiBF;EAfA;IACE,8BAAA;EAiBF;AACF;AAfA;EACE;IACE,2BAAA;IACA,uBAAA;IACA,2BAAA;EAiBF;EAfA;IACE,2BAAA;IACA,uBAAA;IACA,2BAAA;EAiBF;EAfA;IACE,6BAAA;IACA,2BAAA;EAiBF;AACF;AAfA;EACE;IACE,qCAAA;IACA,mBAAA;IACA,iBAAA;EAiBF;EAfA;IACE,qBAAA;IACA,oBAAA;IACA,sBAAA;EAiBF;EAfA;IACE,kCAAA;IACA,sBAAA;IACA,oBAAA;IACA,sBAAA;EAiBF;EAfA;IACE,iCAAA;IACA,mBAAA;IACA,+BAAA;IACA,8BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,6BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,4BAAA;IACA,6BAAA;EAiBF;EAfA;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;EAiBF;EAfA;IACE,iCAAA;IACA,oBAAA;IACA,wBAAA;IACA,8BAAA;IACA,8BAAA;IACA,wCAAA;EAiBF;EAfA;IACE,0BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,6BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,6BAAA;IACA,gCAAA;EAiBF;EAfA;IACE,sBAAA;IACA,uBAAA;IACA,uBAAA;IACA,0BAAA;IACA,6BAAA;IACA,6BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,6BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,4BAAA;IACA,6BAAA;IACA,6BAAA;EAiBF;EAfA;IACE,kCAAA;IACA,4BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,0BAAA;IACA,wBAAA;IACA,8BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,8BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,2BAAA;IACA,6BAAA;EAiBF;EAfA;IACE,0BAAA;IACA,4BAAA;IACA,6BAAA;EAiBF;AACF;AAfA;EAEE;IACE,kCAAA;IACA,4BAAA;EAgBF;EAdA;IACE,0BAAA;IACA,0BAAA;IACA,wBAAA;IACA,8BAAA;IACA,wCAAA;EAgBF;EAdA;IACE,0BAAA;IACA,8BAAA;EAgBF;EAdA;IACE,0BAAA;IACA,6BAAA;EAgBF;EAdA;;IAEE,0BAAA;IACA,2BAAA;IACA,6BAAA;IACA,6BAAA;EAgBF;EAdA;IACE,0BAAA;IACA,4BAAA;IACA,6BAAA;IACA,6BAAA;EAgBF;EAdA;IACE,mBAAA;EAgBF;AACF;AAZA;EACE,eAAA;EACA,MAAA;EAAQ,OAAA;EAAS,QAAA;EAAU,SAAA;EAC3B,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAiBF;;AAfA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;AAkBF;;AAhBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAmBF;;AAjBA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAoBF;;AAlBA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAqBF;;AAnBA;EACE,mBAAA;EACA,cAAA;EACA,gCAAA;AAsBF;;AApBA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAuBF;;AArBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAwBF;;AAtBA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AAyBF;;AAvBA;EACE,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AA0BF;;AAxBA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA2BF;;AAzBA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AA4BF;;AA1BA;EACE,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AA6BF;;AA3BA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA8BF;;AA5BA;EACE,UAAA;EACA,gBAAA;EACA,SAAA;AA+BF;;AA7BA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;AAgCF;;AA9BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;AAiCF;;AA/BA;EACE,eAAA;EACA,iBAAA;AAkCF;;AAhCA;EACE,SAAA;EACA,YAAA;AAmCF;;AAjCA;EACE,cAAA;EACA,0BAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AAoCF;;AAlCA;EACE,WAAA;EACA,eAAA;EACA,eAAA;AAqCF;;AAnCA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAsCF;;AApCA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AAuCF;;AArCA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAwCF;;AArCA;EACE;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;IACA,8BAAA;EAwCF;EAtCA;IACE,0BAAA;EAwCF;EAtCA;IACE,4BAAA;IACA,2BAAA;EAwCF;EAtCA;IACE,sBAAA;IACA,uBAAA;IACA,6BAAA;EAwCF;EAtCA;IACE,0BAAA;EAwCF;EAtCA;IACE,0BAAA;IACA,2BAAA;IACA,6BAAA;EAwCF;AACF;AAtCA;EACE;IACE,qCAAA;IACA,mBAAA;IACA,iBAAA;EAwCF;EAtCA;IACE,qBAAA;IACA,oBAAA;IACA,sBAAA;EAwCF;EAtCA;IACE,kCAAA;IACA,sBAAA;IACA,oBAAA;IACA,sBAAA;EAwCF;EAtCA;IACE,0BAAA;IACA,4BAAA;IACA,6BAAA;IACA,8BAAA;EAwCF;EAtCA;IACE,0BAAA;IACA,8BAAA;IACA,sBAAA;EAwCF;EAtCA;IACE,8BAAA;IACA,mBAAA;IACA,2BAAA;IACA,iCAAA;IACA,oBAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;EAwCF;EAtCA;IACE,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,0BAAA;EAwCF;EAtCA;IACE,sBAAA;IACA,wBAAA;IACA,0BAAA;IACA,6BAAA;IACA,8BAAA;EAwCF;AACF;AApCA;EACE;IACE,iCAAA;IACA,qBAAA;EAsCF;EApCA;IACE,iCAAA;IACA,iBAAA;IACA,oBAAA;IACA,8BAAA;EAsCF;EApCA;IACE,uCAAA;IACA,mBAAA;IACA,mBAAA;IACA,6BAAA;IACA,8BAAA;IACA,0BAAA;EAsCF;EApCA;IACE,0BAAA;IACA,8BAAA;IACA,2BAAA;EAsCF;EApCA;IACE,6BAAA;IACA,0BAAA;IACA,4BAAA;EAsCF;EApCA;;IAEE,0BAAA;IACA,4BAAA;IACA,uBAAA;IACA,WAAA;IACA,kBAAA;EAsCF;EApCA;IACE,0BAAA;IACA,0BAAA;EAsCF;EApCA;IACE,0BAAA;IACA,gBAAA;EAsCF;EApCA;IACE,iCAAA;IACA,kCAAA;IACA,mBAAA;IACA,wBAAA;IACA,0BAAA;EAsCF;EApCA;IACE,0BAAA;IACA,8BAAA;EAsCF;EApCA;IACE,0BAAA;IACA,qBAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;EApCA;IACE,6BAAA;EAsCF;EApCA;IACE,qBAAA;EAsCF;AACF;AApCA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;AAsCF;;AAnCA;EACE;IACE,iCAAA;IACA,iBAAA;IACA,2BAAA;EAsCF;EApCA;IACE,8BAAA;EAsCF;EApCA;IACE,uBAAA;IACA,0BAAA;IACA,sBAAA;EAsCF;EApCA;IACE,yBAAA;IACA,2BAAA;IACA,uBAAA;IACA,0BAAA;IACA,sBAAA;IACA,4BAAA;IACA,sBAAA;EAsCF;AACF;AApCA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAsCF;;AAnCA;EACE;IACE,iCAAA;IACA,mBAAA;IACA,+BAAA;IACA,0BAAA;EAsCF;AACF","sourcesContent":["/* Множественный выбор учеников в модалке расписания */\n.modal-multiselect-trigger {\n  width: 100%;\n  text-align: left;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1.5px solid #d1d1e0;\n  background: #fff;\n}\n.modal-multiselect-trigger--open {\n  border-color: #6c3be4;\n}\n.modal-multiselect-dd {\n  position: absolute;\n  top: 110%;\n  left: 0; right: 0;\n  background: #fff;\n  border: 1px solid #ece9f7;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(108,59,228,0.12);\n  padding: 10px;\n  z-index: 40;\n  max-height: 280px;\n  overflow-y: auto;\n}\n.modal-multiselect-search {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #e0e0ef;\n  margin-bottom: 8px;\n}\n.modal-multiselect-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 8px;\n  border-radius: 8px;\n}\n.modal-multiselect-item:hover {\n  background: #faf8ff;\n}\n.modal-multiselect-item input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n}\n\n/* Переключатель режима назначения занятий */\n.assign-switch {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px;\n  background: #f3f0fa;\n  border: 1px solid #ece9f7;\n  border-radius: 10px;\n  padding: 4px;\n}\n.assign-switch-btn {\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 10px;\n  font-weight: 600;\n  color: #6c3be4;\n  cursor: pointer;\n}\n.assign-switch-btn.is-active {\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n}\n@import url(https://fonts.googleapis.com/css?family=Montserrat:100,200,300,regular,500,600,700,800,900,100italic,200italic,300italic,italic,500italic,600italic,700italic,800italic,900italic);\n\n$primary-color: #41424C;\n\nbody{\n    margin: 0;\n    padding: 0;\n    font-family: Montserrat;\n}\n\n*{\n    font-family: Montserrat;\n}\n\n[class*=\"__container\"]{\n    max-width: 1170px;\n    margin: 0px auto;\n}\n\ninput{\n    padding: 10px 20px;\n    width: 100%;\n    box-sizing: border-box;\n    border: 1px solid #cacaca;\n    border-radius: 5px;\n\n    &:focus{\n        border: 1px solid $primary-color;\n        outline: none;\n    }\n}\n\n.button{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    padding: 10px 20px;\n    background: $primary-color;\n    border-radius: 5px;\n    color: #fff;\n    text-decoration: none;\n    box-sizing: border-box;\n    transition: 0.3s;\n\n    &:hover{\n        background: #4c20bbb4;\n    }\n}\n\n.Sidebar{\n    height: 100vh;\n    background: $primary-color;\n    width: 200px;\n    position: fixed;\n\n    .logo{\n        text-align: center;\n        padding-top: 20px;\n        font-size: 24px;\n        color: #fff;\n        font-weight: 700;\n    }\n\n    ul{\n        li{\n            list-style: none;\n            color: #fff;\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            margin: 20px 0px;\n\n            a{\n                color: #fff;\n                text-decoration: none;\n\n                &.active{\n                    font-weight: 700;\n                }\n            }\n        }\n    }\n\n    .leave{\n        position: absolute;\n        text-align: center;\n        left: 0;\n        bottom: 20px;\n        width: 100%;\n\n        a{\n            display: flex;\n            justify-content: center;\n            width: 100%;\n            color: #fff;\n            text-decoration: none;\n        }\n    }\n}\n\n.Header{\n    width: 100%;\n    background: $primary-color;\n    padding: 10px 0px;\n\n    .Header__container{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        .logo{\n            font-size: 22px;\n            color: #fff;\n            font-weight: 600;\n        }\n\n        .menu{\n            ul{\n                display: flex;\n                gap: 20px;\n\n                li{\n                    list-style: none;\n\n                    a{\n                        color: #fff;\n                        text-decoration: none;\n\n                        &.active{\n                            border-bottom: 2px solid #d1d1d1;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.Auth{\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .AuthBlock{\n        width: 400px;\n        padding: 25px;\n        box-sizing: border-box;\n        box-shadow: 0px 0px 7px 0px rgba(34, 60, 80, 0.2);\n        border-radius: 10px;\n\n        .title{\n            text-align: center;\n            font-size: 18px;\n            font-weight: 500;\n        }\n\n        .inputBlock{\n            margin: 10px 0px;\n        }\n\n        .passwordBlock {\n            position: relative;\n\n            input {\n                width: 100%;\n                padding-right: 40px; \n            }\n\n            .toggleIcon {\n                position: absolute;\n                right: 10px;\n                top: 55%;\n                transform: translateY(-50%);\n                cursor: pointer;\n                color: #888;\n\n                &:hover {\n                color: #000;\n                }\n            }\n        }\n    }\n}\n\n.Home{\n    .Schedule{\n        // Старые стили для обратной совместимости\n        .Schedule__collumn{\n            width: 100%;\n            height: 100%;\n            background: #f1f1f1;\n            padding: 10px;\n            box-sizing: border-box;\n            border-radius: 5px;\n\n            .title{\n                text-align: center;\n                color:$primary-color;\n                font-weight: 600;\n                padding-bottom: 10px;\n                border-bottom: 1px solid #dddddd;\n            }\n        }\n\n        .ScheduleBlockk{\n            padding: 10px;\n            background: #fff;\n            margin: 10px 0px;\n            font-size: 14px;\n            border-radius: 5px;\n            width: 100%;\n            box-sizing: border-box;\n      \n\n            .textBlock{\n                margin: 5px 0px;\n\n                span{\n                    font-weight: 500;\n                }\n            }\n\n            a{\n                margin-top: 10px;\n            }\n        }\n    }\n}\n\n.News{\n\n    .News__container{\n        display: flex;\n        gap: 30px;\n        flex-wrap: wrap;\n        padding-top: 20px;\n\n        .NewsBlock{\n            width: 370px;\n            background: #ffffff;\n            box-shadow: 0px 0px 6px 0px rgba(34, 60, 80, 0.2);\n            border-radius: 5px;\n\n            .image{\n                img{\n                    width: 100%;\n                    height: 200px;\n                    object-fit: cover;\n                }\n            }\n\n            .body{\n                padding: 10px;\n                box-sizing: border-box;\n                \n                .date{\n                    font-size: 12px;\n                    opacity: 0.5;\n                    margin-bottom: 5px;\n                }\n\n                .title{\n                    margin-bottom: 10px;\n                    font-size: 18px;\n                    font-weight: 500;\n                }\n\n                .text {\n                    display: -webkit-box;\n                    -webkit-line-clamp: 3;\n                    -webkit-box-orient: vertical;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    margin-bottom: 10px;\n                    font-size: 15px;\n                }\n            }\n        }\n    }\n}\n\n.NewsFull{\n    .NewsFull__container{\n        display: flex;\n        padding-top: 20px;\n        gap: 40px;\n\n        .left{\n            width: 40%;\n             \n            .image{\n                img{\n                    width: 100%;\n                    border-radius: 5px;\n                }\n            }\n        }\n\n        .right{\n            width: 55%;\n\n            .title{\n                font-size: 24px;\n                font-weight: 600;\n            }\n\n            .text{\n                margin-top: 10px;\n            }\n\n            .date{\n                font-size: 12px;\n                opacity: 0.5;\n                margin-bottom: 5px;\n                margin-top: 30px;\n            }\n        }\n    }\n}\n\n.AdminHeader{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .title{\n        font-size: 20px;\n        font-weight: 500;\n    }\n}\n\n.AdminGroups__container{\n    display: flex;\n    gap: 40px;\n\n    .search{\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n\n    .table__title{\n        display: flex;\n        justify-content: space-between;\n\n        .title{\n            font-size: 14px;\n            font-weight: 600;\n        }\n\n        .title_group{\n            width: 150px;\n        }\n\n        .quantity__group{\n            width: 180px;\n        }\n\n        .rasp__group{\n            width: 150px;\n        }\n\n        .full_group{\n            width: 150px;\n        }\n    }\n\n    .GroupBlock{\n        width: 100%;\n        background: #f5f5f5;\n        padding: 10px;\n        border-radius: 5px;\n        margin: 10px 0px;\n        display: flex;\n        justify-content: space-between;\n        text-align: start;\n        box-sizing: border-box;\n        align-items: center;\n\n        .title_group{\n            width: 150px;\n        }\n\n        .quantity__group{\n            width: 180px;\n        }\n\n        .rasp__group{\n            width: 150px;\n\n            a{\n                font-size: 12px;\n                padding: 5px;\n            }\n        }\n\n        .full_group{\n            width: 150px;\n\n            a{\n                font-size: 12px;\n                padding: 5px;\n            }\n        }\n    }\n}\n\n.content_admin{\n    padding-top: 20px;\n    width: 900px;\n    margin-left: 240px;\n\n/*     &::-webkit-scrollbar{\n        display: none;\n    } */\n\n/*     &::-webkit-scrollbar-track{\n        background: #000;\n    } */\n}\n\n.AdminUsers{\n    .AdminUsers__container{\n        display: flex;\n        gap: 40px;\n\n        .search{\n            margin-top: 20px;\n        }\n\n        .table__title{\n            display: flex;\n            justify-content: space-between;\n            margin-top: 20px;\n\n            .title{\n                font-size: 14px;\n                font-weight: 600;\n            }\n\n            .user_name{\n                width: 140px;\n            }\n\n            .user_group{\n                width: 80px;\n            }\n\n            .user_pay,\n            .user_rasp,\n            .user_full{\n                width: 120px;\n            }\n        }\n\n        .UserBlock{\n            width: 100%;\n            background: #f5f5f5;\n            padding: 10px;\n            border-radius: 5px;\n            margin: 10px 0px;\n            display: flex;\n            justify-content: space-between;\n            text-align: start;\n            box-sizing: border-box;\n            align-items: center;\n\n            .user_name{\n                width: 140px;\n                font-size: 12px;\n            }\n\n            .user_group{\n                width: 80px;\n                font-size: 14px;\n            }\n\n            .user_pay,\n            .user_rasp,\n            .user_full{\n                width: 120px;\n            }\n\n            a{\n                font-size: 12px;\n                padding: 5px;\n            }\n        }\n    }\n}\n\n.AdminUsers__container .UserBlock {\n  display: flex;\n  align-items: center;\n}\n.AdminUsers__container .UserBlock > .title {\n  flex: 1 1 0;\n  min-width: 120px;\n  max-width: 220px;\n  text-align: left;\n  padding: 0 8px;\n}\n.AdminUsers__container .UserBlock > .user_pay,\n.AdminUsers__container .UserBlock > .user_rasp,\n.AdminUsers__container .UserBlock > .user_full {\n  min-width: 150px;\n  max-width: 180px;\n  text-align: center;\n}\n\n.admin-users-row {\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n}\n.admin-users-schedule-btn {\n  background: #4c20bb;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 16px;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  margin-left: 12px;\n  transition: background 0.2s;\n}\n.admin-users-schedule-btn:hover {\n  background: #6c3be4;\n}\n.admin-users-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.3);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.admin-users-modal-content {\n  background: #fff;\n  border-radius: 12px;\n  padding: 32px;\n  min-width: 320px;\n  max-width: 400px;\n}\n.admin-users-modal-btn {\n  padding: 6px 16px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  background: #f5f5f5;\n  color: #222;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n.admin-users-modal-btn-primary {\n  background: #6c3be4;\n  color: #fff;\n  border: none;\n}\n.admin-users-modal-btn-primary:hover {\n  background: #4c20bb;\n}\n.ScheduleBlock, .ScheduleBlock.filled, .ScheduleBlock.empty {\n  width: 100%;\n  padding: 16px;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px #ece9f7;\n  margin-bottom: 12px;\n  box-sizing: border-box;\n  overflow: hidden;\n  display: block;\n}\n.ScheduleBlock.empty {\n  background: #f5f5f5;\n  box-shadow: none;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n.Schedule__column {\n  width: 180px;\n  min-width: 180px;\n  max-width: 180px;\n}\n.scheduleblock-content {\n  margin-bottom: 8px;\n}\n.scheduleblock-time {\n  color: #6c3be4;\n  font-weight: 600;\n  font-size: 15px;\n  margin-bottom: 2px;\n}\n.scheduleblock-group {\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n.scheduleblock-subject {\n  font-size: 14px;\n  color: #222;\n  margin-bottom: 2px;\n}\n.scheduleblock-comment {\n  font-size: 13px;\n  color: #888;\n  margin-top: 2px;\n}\n.scheduleblock-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.scheduleblock-edit-btn, .scheduleblock-details-btn {\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n.scheduleblock-edit-btn {\n  background: none;\n  border: 1px solid #6c3be4;\n  color: #6c3be4;\n  border-radius: 6px;\n  padding: 4px 14px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n.scheduleblock-edit-btn:hover {\n  background: #6c3be4;\n  color: #fff;\n}\n.scheduleblock-details-btn {\n  background: #6c3be4;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 4px 14px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.scheduleblock-details-btn:hover {\n  background: #4c20bb;\n}\n\n.admin-user-schedule-wrapper {\n  padding-top: 24px;\n}\n.admin-user-back-btn {\n  margin-bottom: 20px;\n  background: #4c20bb;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 16px;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.admin-user-back-btn:hover {\n  background: #6c3be4;\n}\n.admin-user-title {\n  margin-bottom: 24px;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.admin-users-table-wrapper {\n  margin-top: 24px;\n  overflow-x: auto;\n}\n.admin-users-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px #ece9f7;\n  font-size: 15px;\n}\n.admin-users-table th, .admin-users-table td {\n  padding: 14px 16px;\n  text-align: left;\n}\n.admin-users-table th {\n  background: #f5f5f5;\n  font-weight: 600;\n  font-size: 16px;\n}\n.admin-users-table tr {\n  border-bottom: 1px solid #ece9f7;\n}\n.admin-users-table tr:last-child {\n  border-bottom: none;\n}\n.admin-users-table td {\n  vertical-align: middle;\n}\n\n.admin-user-full-wrapper {\n  padding-top: 24px;\n}\n.admin-user-full-info {\n  background: #f8f7fc;\n  border-radius: 10px;\n  padding: 24px 32px;\n  font-size: 16px;\n  margin-top: 16px;\n  box-shadow: 0 2px 8px #ece9f7;\n  max-width: 400px;\n}\n\n/* Выбор групп в профиле ученика */\n.user-groups-picker {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.user-groups-trigger {\n  background: #fff;\n  border: 1.5px solid #d1d1e0;\n  color: #333;\n  border-radius: 10px;\n  padding: 10px 14px;\n  min-width: 260px;\n  text-align: left;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.04);\n}\n.user-groups-trigger--open {\n  border-color: #6c3be4;\n}\n.user-groups-dd {\n  position: absolute;\n  top: 48px;\n  left: 0;\n  width: 360px;\n  background: #fff;\n  border: 1px solid #ece9f7;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(108,59,228,0.18);\n  padding: 12px;\n  z-index: 100;\n}\n.user-groups-dd-head {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.user-groups-search {\n  flex: 1;\n  padding: 8px 12px;\n  border-radius: 10px;\n  border: 1px solid #e6e6ef;\n  background: #fafaff;\n}\n.user-groups-dd-btn {\n  background: #f4efff;\n  color: #6c3be4;\n  border: 1px solid #e8e3fb;\n  border-radius: 10px;\n  padding: 8px 12px;\n  font-weight: 600;\n}\n.user-groups-dd-btn--clear {\n  background: #f9f9fb;\n  color: #666;\n  border: 1px solid #e6e6ef;\n}\n.user-groups-list {\n  max-height: 300px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n.user-groups-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n.user-groups-item:hover {\n  background: #faf8ff;\n}\n.user-groups-item input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n}\n.user-groups-chips {\n  margin-top: 10px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.user-groups-chip {\n  background: #f1edfe;\n  color: #6c3be4;\n  border: 1px solid #e8e3fb;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n}\n.admin-groups-table-wrapper {\n  margin-top: 24px;\n  overflow-x: auto;\n}\n.admin-groups-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px #ece9f7;\n  font-size: 15px;\n  min-width: 480px;\n}\n.admin-groups-table th, .admin-groups-table td {\n  padding: 12px 16px;\n  text-align: left;\n}\n.admin-groups-table th.center, .admin-groups-table td.center {\n  text-align: center;\n}\n.admin-groups-table th {\n  background: #f7f7f9;\n  font-weight: 600;\n  font-size: 16px;\n  border-bottom: 1px solid #ece9f7;\n}\n.admin-groups-table-row {\n  background: #fff;\n  border-radius: 8px;\n  transition: background 0.2s;\n}\n.admin-groups-table-row:hover {\n  background: #f8f7fc;\n}\n.admin-groups-drop-indicator td {\n  padding: 0 !important;\n}\n.admin-groups-drop-indicator {\n  height: 8px;\n}\n.admin-groups-drop-indicator td::after {\n  content: '';\n  display: block;\n  height: 8px;\n  background: #6c3be4;\n  opacity: 0.25;\n  border-radius: 4px;\n}\n.admin-groups-table-loading, .admin-groups-table-empty {\n  text-align: center;\n  color: #888;\n  padding: 20px;\n}\n.admin-groups-table-name {\n  font-weight: 500;\n  font-size: 16px;\n}\n.admin-groups-table-count {\n  text-align: center;\n  font-size: 15px;\n}\n.admin-groups-table-actions {\n  text-align: center;\n}\n.admin-groups-btn {\n  background: #6c3be4;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 16px;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-bottom: 2px;\n}\n.admin-groups-btn-secondary {\n  background: #f5f5f5;\n  color: #4c20bb;\n  border: 1px solid #6c3be4;\n}\n.admin-groups-btn-secondary:hover {\n  background: #ece9f7;\n  color: #6c3be4;\n}\n// AdminSchedule стили\n.adminschedule-header {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 24px;\n  align-items: center;\n}\n.adminschedule-header-label {\n  font-weight: 500;\n}\n.adminschedule-select {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n}\n.AdminSchedule-kanban {\n  display: flex;\n  gap: 24px;\n}\n.Schedule__column {\n  flex: 1;\n}\n.adminschedule-title {\n  text-align: center;\n  margin-bottom: 12px;\n}\n.ScheduleBlock.empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 80px;\n  background: #f5f5f5;\n  border-radius: 10px;\n  margin-bottom: 12px;\n  flex-direction: column;\n}\n.scheduleblock-empty-time {\n  color: #888;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n.add-slot-btn {\n  font-size: 28px;\n  color: #6c3be4;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.scheduleblock-delete-btn {\n  background: #e74c3c;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 4px 14px;\n  font-size: 14px;\n  margin-top: 4px;\n}\n\n// --- AdminGroups ---\n.AdminGroups {\n  padding: 0 0 70px 0;\n  background: #f8f7fc;\n  min-height: 100vh;\n}\n.AdminGroups__container {\n  display: flex;\n  gap: 40px;\n  align-items: flex-start;\n}\n.admin-groups-search {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  max-width: 400px;\n}\n.admin-groups-table-wrapper {\n  margin-top: 24px;\n  overflow-x: auto;\n}\n.admin-groups-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px #ece9f7;\n  font-size: 15px;\n  min-width: 480px;\n}\n.admin-groups-table th, .admin-groups-table td {\n  padding: 14px 18px;\n  text-align: left;\n}\n.admin-groups-table th {\n  background: #f7f7f9;\n  font-weight: 600;\n  font-size: 16px;\n  border-bottom: 1px solid #ece9f7;\n}\n.admin-groups-table-row {\n  background: #f7f7f9;\n  border-radius: 8px;\n  transition: background 0.2s;\n}\n.admin-groups-table-row:hover {\n  background: #f0ebff;\n}\n.admin-groups-table-loading, .admin-groups-table-empty {\n  text-align: center;\n  color: #888;\n  padding: 20px;\n}\n.admin-groups-table-name {\n  font-weight: 500;\n  font-size: 16px;\n}\n.admin-groups-table-count {\n  text-align: center;\n  font-size: 15px;\n}\n.admin-groups-table-actions {\n  text-align: center;\n}\n.admin-groups-btn {\n  background: #6c3be4;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 16px;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-bottom: 2px;\n}\n.admin-groups-btn-secondary {\n  background: #f5f5f5;\n  color: #4c20bb;\n  border: 1px solid #6c3be4;\n}\n.admin-groups-btn-secondary:hover {\n  background: #ece9f7;\n  color: #6c3be4;\n}\n// --- Модалка ---\n.admin-groups-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.3);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.admin-groups-modal-content {\n  background: #fff;\n  border-radius: 12px;\n  padding: 32px;\n  min-width: 320px;\n  max-width: 400px;\n  box-shadow: 0 2px 12px #ece9f7;\n}\n.admin-groups-modal-title {\n  margin-bottom: 20px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #6c3be4;\n  text-align: center;\n}\n.admin-groups-modal-field {\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n}\n.admin-groups-modal-field label {\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n.admin-groups-modal-field input {\n  width: 100%;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  font-size: 15px;\n}\n.admin-groups-modal-error {\n  color: #e74c3c;\n  margin-bottom: 8px;\n  text-align: center;\n}\n.admin-groups-modal-success {\n  background: #f5f5f5;\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 10px;\n  text-align: center;\n}\n.admin-groups-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n.admin-groups-modal-btn {\n  padding: 6px 16px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  background: #f5f5f5;\n  color: #222;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n.admin-groups-modal-btn-primary {\n  background: #6c3be4;\n  color: #fff;\n  border: none;\n}\n.admin-groups-modal-btn-primary:hover {\n  background: #4c20bb;\n}\n\n// ====== АДАПТИВ ======\n@media (max-width: 900px) {\n  .Home .Schedule {\n    flex-wrap: wrap;\n    gap: 20px;\n    justify-content: flex-start;\n  }\n  .Home .Schedule__collumn {\n    width: 48%;\n    min-width: 220px;\n    max-width: 100%;\n  }\n  .Home__container, .News__container, .NewsFull__container {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n  .AdminUsers__container, .AdminGroupFull__container, .AdminRasp__container, .content_admin {\n    flex-direction: column !important;\n    gap: 0 !important;\n    width: 100% !important;\n    margin-left: 0 !important;\n    padding: 0 6px !important;\n    box-sizing: border-box;\n  }\n  .Sidebar {\n    position: static !important;\n    width: 100% !important;\n    min-width: 0 !important;\n    height: auto !important;\n    box-shadow: none !important;\n    margin-bottom: 16px;\n  }\n  .content_admin {\n    width: 100% !important;\n    margin-left: 0 !important;\n    padding: 0 6px !important;\n    box-sizing: border-box;\n  }\n  .AdminSchedule-kanban, .AdminRasp .AdminSchedule-kanban {\n    display: flex !important;\n    flex-direction: row !important;\n    gap: 12px !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 16px;\n    margin-bottom: 0;\n    width: 100%;\n    max-width: 100vw;\n  }\n  .Schedule__column {\n    min-width: 220px !important;\n    max-width: 260px !important;\n    width: 90vw !important;\n  }\n  .AdminGroups__container {\n    flex-direction: column !important;\n    gap: 0 !important;\n    width: 100% !important;\n    margin-left: 0 !important;\n    padding: 0 6px !important;\n    box-sizing: border-box;\n  }\n  .content_admin {\n    width: 100% !important;\n    margin-left: 0 !important;\n    padding: 0 6px !important;\n    box-sizing: border-box;\n  }\n  .Sidebar, .admin-sidebar {\n    display: none !important;\n  }\n  .AdminGroups {\n    padding: 0 0 70px 0 !important;\n  }\n  .admin-groups-table {\n    min-width: 320px;\n    font-size: 13px;\n  }\n  .admin-groups-modal-content {\n    min-width: 90vw;\n    max-width: 98vw;\n    padding: 16px;\n  }\n  .adminrasp-gradient-shadow {\n    display: none !important;\n  }\n}\n@media (max-width: 600px) {\n  .Auth {\n    align-items: flex-start;\n    padding-top: 40px;\n    height: auto;\n  }\n  .Auth .AuthBlock {\n    width: 100%;\n    min-width: 0;\n    max-width: 98vw;\n    padding: 16px;\n    box-shadow: 0px 0px 4px 0px rgba(34, 60, 80, 0.13);\n  }\n  .Home .Schedule {\n    flex-direction: column;\n    gap: 16px;\n    align-items: stretch;\n  }\n  .Home .Schedule__collumn {\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    margin-bottom: 12px;\n  }\n  .ScheduleBlockk {\n    font-size: 13px;\n    padding: 8px;\n  }\n  .Home__container, .News__container, .NewsFull__container {\n    padding-left: 6px;\n    padding-right: 6px;\n    padding-bottom: 80px; // чтобы не перекрывало bottom nav\n    box-sizing: border-box;\n  }\n  .NewsFull__container {\n    flex-direction: column !important;\n    gap: 0 !important;\n  }\n  .NewsFull__container .left, .NewsFull__container .right {\n    width: 100% !important;\n    max-width: 100% !important;\n    padding: 0 !important;\n  }\n  .NewsFull__container .left .image img {\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n    margin-bottom: 12px;\n  }\n  .NewsFull__container .right .title {\n    font-size: 20px;\n    margin-top: 8px;\n  }\n  .AdminUsers__container, .AdminGroupFull__container, .AdminRasp__container, .content_admin {\n    flex-direction: column !important;\n    gap: 0 !important;\n    width: 100% !important;\n    margin-left: 0 !important;\n    padding: 0 2px !important;\n    box-sizing: border-box;\n  }\n  .Sidebar {\n    display: none !important;\n  }\n  .content_admin {\n    width: 100% !important;\n    margin-left: 0 !important;\n    padding: 0 2px !important;\n    box-sizing: border-box;\n  }\n  .AdminSchedule-kanban, .AdminRasp .AdminSchedule-kanban {\n    display: flex !important;\n    flex-direction: row !important;\n    gap: 8px !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 16px;\n    margin-bottom: 0;\n    width: 100%;\n    max-width: 100vw;\n  }\n  .Schedule__column {\n    min-width: 180px !important;\n    max-width: 220px !important;\n    width: 90vw !important;\n  }\n  .admin-sidebar, .Sidebar {\n    display: none !important;\n  }\n  .content_admin {\n    width: 100% !important;\n    margin: 0 !important;\n    padding-bottom: 70px !important; // чтобы контент не перекрывался bottom nav\n  }\n  .AdminGroups__container {\n    flex-direction: column !important;\n    padding: 0 !important;\n  }\n  .AdminGroups {\n    padding: 0 0 70px 0 !important;\n  }\n  .admin-groups-table {\n    min-width: 320px;\n    font-size: 13px;\n  }\n  .admin-groups-modal-content {\n    min-width: 90vw;\n    max-width: 98vw;\n    padding: 16px;\n  }\n  .AdminGroups {\n    padding: 12px 8px 70px 8px !important;\n    background: #f8f7fc;\n    min-height: 100vh;\n  }\n  .AdminGroups__container {\n    padding: 0 !important;\n    margin: 0 !important;\n    width: 100% !important;\n  }\n  .content_admin {\n    padding: 0 2px 70px 2px !important;\n    width: 100% !important;\n    margin: 0 !important;\n    box-sizing: border-box;\n  }\n  .AdminHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    margin-bottom: 10px;\n    .title {\n      font-size: 17px;\n      margin-bottom: 2px;\n    }\n    .buttton {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      button, a, .button {\n        font-size: 14px !important;\n        padding: 8px 14px !important;\n        border-radius: 7px !important;\n      }\n    }\n  }\n  .admin-groups-search input {\n    font-size: 14px;\n    padding: 8px 10px;\n    border-radius: 7px;\n    margin-bottom: 8px;\n  }\n  .admin-groups-table {\n    min-width: 0;\n    font-size: 12px;\n    border-radius: 10px;\n    box-shadow: 0 1px 4px #ece9f7;\n  }\n  .admin-groups-table th, .admin-groups-table td {\n    padding: 8px 6px;\n    font-size: 12px;\n  }\n  .admin-groups-table th {\n    font-size: 13px;\n    background: #f3f0fa;\n  }\n  .admin-groups-table-row {\n    border-radius: 8px;\n    background: #fff;\n    border-bottom: 1px solid #ece9f7;\n  }\n  .admin-groups-table-row:last-child {\n    border-bottom: none;\n  }\n  .admin-groups-btn {\n    font-size: 12px;\n    padding: 5px 10px;\n    border-radius: 7px;\n    min-width: 0;\n    margin: 0 auto;\n    display: block;\n  }\n  .admin-groups-btn-secondary {\n    background: #f8f7fc;\n    color: #6c3be4;\n    border: 1px solid #ece9f7;\n  }\n  .admin-groups-btn-secondary:hover {\n    background: #ece9f7;\n    color: #4c20bb;\n  }\n  .admin-groups-modal-content {\n    min-width: 96vw;\n    max-width: 99vw;\n    padding: 10px;\n    border-radius: 10px;\n  }\n  .admin-groups-modal-title {\n    font-size: 16px;\n    margin-bottom: 10px;\n  }\n  .admin-groups-modal-field input {\n    font-size: 13px;\n    padding: 7px 8px;\n    border-radius: 7px;\n  }\n  .admin-groups-modal-btn {\n    font-size: 13px;\n    padding: 6px 10px;\n    border-radius: 7px;\n  }\n  .admin-groups-modal-btn-primary {\n    font-size: 13px;\n    padding: 6px 10px;\n    border-radius: 7px;\n  }\n  // Bottom nav\n  nav {\n    height: 52px !important;\n    min-height: 52px !important;\n    max-height: 52px !important;\n    .MuiBottomNavigationAction-label, span {\n      font-size: 11px !important;\n    }\n    button {\n      font-size: 20px !important;\n      padding: 0 2px !important;\n    }\n  }\n}\n@media (max-width: 600px) {\n  .AdminUsers {\n    padding: 12px 8px 70px 8px !important;\n    background: #f8f7fc;\n    min-height: 100vh;\n  }\n  .AdminUsers__container {\n    padding: 0 !important;\n    margin: 0 !important;\n    width: 100% !important;\n  }\n  .content_admin {\n    padding: 0 2px 70px 2px !important;\n    width: 100% !important;\n    margin: 0 !important;\n    box-sizing: border-box;\n  }\n  .AdminHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    margin-bottom: 10px;\n    .title {\n      font-size: 17px;\n      margin-bottom: 2px;\n    }\n    .buttton {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      button, a, .button {\n        font-size: 14px !important;\n        padding: 8px 14px !important;\n        border-radius: 7px !important;\n      }\n    }\n  }\n  .search input {\n    font-size: 14px;\n    width: 100% !important;\n    padding: 8px 10px;\n    border-radius: 7px;\n    margin-bottom: 8px;\n  }\n  .admin-users-table {\n    min-width: 0;\n    font-size: 12px;\n    border-radius: 10px;\n    box-shadow: 0 1px 4px #ece9f7;\n  }\n  .admin-users-table th, .admin-users-table td {\n    padding: 8px 6px;\n    font-size: 12px;\n  }\n  .admin-users-table th {\n    font-size: 13px;\n    background: #f3f0fa;\n  }\n  .admin-users-table tr {\n    border-radius: 8px;\n    background: #fff;\n    border-bottom: 1px solid #ece9f7;\n  }\n  .admin-users-table tr:last-child {\n    border-bottom: none;\n  }\n  .admin-users-schedule-btn {\n    font-size: 12px;\n    padding: 5px 10px;\n    border-radius: 7px;\n    min-width: 0;\n    margin: 0 auto;\n    display: block;\n  }\n  .admin-users-modal-content {\n    min-width: 96vw;\n    max-width: 99vw;\n    padding: 10px;\n    border-radius: 10px;\n  }\n  .admin-users-modal-title {\n    font-size: 16px;\n    margin-bottom: 10px;\n  }\n  .admin-users-modal-field input, .admin-users-modal-field select {\n    font-size: 13px;\n    padding: 7px 8px;\n    border-radius: 7px;\n  }\n  .admin-users-modal-btn {\n    font-size: 13px;\n    padding: 6px 10px;\n    border-radius: 7px;\n  }\n  .admin-users-modal-btn-primary {\n    font-size: 13px;\n    padding: 6px 10px;\n    border-radius: 7px;\n  }\n  .admin-users-modal-overlay {\n    align-items: flex-start;\n    padding-top: 30px;\n  }\n  .admin-users-table-wrapper {\n    margin-top: 16px;\n  }\n  .search {\n    flex-direction: column !important;\n    gap: 8px !important;\n    align-items: stretch !important;\n    margin-bottom: 10px !important;\n    position: static !important;\n  }\n  .search button {\n    font-size: 13px;\n    padding: 7px 10px;\n    border-radius: 7px;\n    width: 100%;\n    margin-top: 4px;\n  }\n  .search select {\n    font-size: 13px;\n    padding: 7px 8px;\n    border-radius: 7px;\n    margin-bottom: 8px;\n  }\n  .search div[style*='position: absolute'] {\n    position: static !important;\n    min-width: 0 !important;\n    box-shadow: 0 1px 4px #ece9f7 !important;\n    border-radius: 10px !important;\n    padding: 10px !important;\n    margin-top: 8px !important;\n  }\n}\n@media (max-width: 600px) {\n  .AdminRasp {\n    padding: 12px 8px 70px 8px !important;\n    background: #f8f7fc;\n    min-height: 100vh;\n  }\n  .AdminRasp__container {\n    padding: 0 !important;\n    margin: 0 !important;\n    width: 100% !important;\n  }\n  .content_admin {\n    padding: 0 2px 70px 2px !important;\n    width: 100% !important;\n    margin: 0 !important;\n    box-sizing: border-box;\n  }\n  .AdminHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    margin-bottom: 10px;\n    .title {\n      font-size: 17px;\n      margin-bottom: 2px;\n    }\n    .buttton {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      button, a, .button {\n        font-size: 14px !important;\n        padding: 8px 14px !important;\n        border-radius: 7px !important;\n      }\n    }\n  }\n  .adminschedule-header {\n    flex-direction: column !important;\n    gap: 8px !important;\n    align-items: stretch !important;\n    margin-bottom: 10px !important;\n  }\n  .adminschedule-header-label {\n    font-size: 13px !important;\n  }\n  .adminschedule-select {\n    font-size: 13px !important;\n    padding: 7px 8px !important;\n    border-radius: 7px !important;\n    margin-bottom: 8px !important;\n  }\n  .AdminSchedule-kanban {\n    flex-direction: row !important;\n    gap: 8px !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 16px;\n    margin-bottom: 0;\n    width: 100%;\n    max-width: 100vw;\n  }\n  .Schedule__column {\n    min-width: 160px !important;\n    max-width: 220px !important;\n    width: 90vw !important;\n    font-size: 12px !important;\n  }\n  .ScheduleBlock, .ScheduleBlock.filled, .ScheduleBlock.empty {\n    width: 100% !important;\n    padding: 10px !important;\n    font-size: 12px !important;\n    border-radius: 8px !important;\n    margin-bottom: 10px !important;\n  }\n  .scheduleblock-time, .scheduleblock-group, .scheduleblock-subject, .scheduleblock-comment {\n    font-size: 12px !important;\n  }\n  .scheduleblock-actions button {\n    font-size: 12px !important;\n    padding: 5px 10px !important;\n    border-radius: 7px !important;\n    margin-bottom: 4px !important;\n  }\n  .add-slot-btn {\n    font-size: 22px !important;\n    border-radius: 7px !important;\n    padding: 0 6px !important;\n  }\n  .scheduleblock-edit-btn, .scheduleblock-details-btn, .scheduleblock-delete-btn {\n    font-size: 12px !important;\n    padding: 5px 10px !important;\n    border-radius: 7px !important;\n  }\n  .scheduleblock-details-btn {\n    margin-top: 4px !important;\n  }\n  .scheduleblock-delete-btn {\n    margin-top: 4px !important;\n  }\n  .admin-user-back-btn {\n    font-size: 13px !important;\n    padding: 6px 10px !important;\n    border-radius: 7px !important;\n    margin-bottom: 10px !important;\n  }\n  .admin-user-title {\n    font-size: 16px !important;\n    margin-bottom: 10px !important;\n  }\n  .admin-user-full-info {\n    font-size: 13px !important;\n    padding: 12px 10px !important;\n    border-radius: 8px !important;\n    margin-top: 10px !important;\n    max-width: 98vw !important;\n  }\n  .admin-user-full-wrapper {\n    padding-top: 10px !important;\n  }\n  .admin-user-schedule-wrapper {\n    padding-top: 10px !important;\n  }\n  .admin-user-back-btn {\n    margin-bottom: 10px !important;\n  }\n}\n@media (max-width: 600px) {\n  .AdminSchedule-kanban, .AdminRasp .AdminSchedule-kanban {\n    box-shadow: none !important;\n    border: none !important;\n    background: none !important;\n  }\n  .Schedule__column {\n    box-shadow: none !important;\n    border: none !important;\n    background: none !important;\n  }\n  .Schedule__column:not(:last-child) {\n    border-right: none !important;\n    box-shadow: none !important;\n  }\n}\n@media (max-width: 600px) {\n  .AdminNews {\n    padding: 12px 8px 70px 8px !important;\n    background: #f8f7fc;\n    min-height: 100vh;\n  }\n  .AdminNews__container {\n    padding: 0 !important;\n    margin: 0 !important;\n    width: 100% !important;\n  }\n  .content_admin {\n    padding: 0 2px 70px 2px !important;\n    width: 100% !important;\n    margin: 0 !important;\n    box-sizing: border-box;\n  }\n  .content_admin > div[style*='display: flex'][style*='margin-bottom: 24px'] {\n    flex-direction: column !important;\n    gap: 8px !important;\n    align-items: stretch !important;\n    margin-bottom: 10px !important;\n  }\n  .content_admin h2 {\n    font-size: 18px !important;\n    margin-bottom: 4px !important;\n  }\n  .content_admin button {\n    font-size: 13px !important;\n    padding: 8px 14px !important;\n    border-radius: 7px !important;\n  }\n  .content_admin ul {\n    padding: 0 !important;\n    margin: 0 !important;\n    max-width: 100vw !important;\n  }\n  .content_admin li {\n    flex-direction: column !important;\n    gap: 10px !important;\n    padding: 14px !important;\n    border-radius: 10px !important;\n    margin-bottom: 16px !important;\n    box-shadow: 0 1px 4px #ece9f7 !important;\n  }\n  .content_admin .NewsBlock, .content_admin li {\n    font-size: 13px !important;\n  }\n  .content_admin .NewsBlock .title, .content_admin li .title {\n    font-size: 15px !important;\n    margin-bottom: 4px !important;\n  }\n  .content_admin .NewsBlock .text, .content_admin li .text {\n    font-size: 13px !important;\n    margin-bottom: 4px !important;\n    -webkit-line-clamp: 4 !important;\n  }\n  .content_admin .NewsBlock img, .content_admin li img {\n    width: 28px!important;\n    height: auto !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    border-radius: 8px !important;\n    margin-bottom: 8px !important;\n  }\n  .content_admin .NewsBlock .date, .content_admin li .date {\n    font-size: 11px !important;\n    margin-bottom: 2px !important;\n  }\n  .content_admin .NewsBlock button, .content_admin li button {\n    font-size: 12px !important;\n    padding: 7px 10px !important;\n    border-radius: 7px !important;\n    margin-bottom: 4px !important;\n  }\n  .modal-overlay, .admin-news-modal-overlay {\n    align-items: flex-start !important;\n    padding-top: 30px !important;\n  }\n  .modal-content, .admin-news-modal-content {\n    min-width: 96vw !important;\n    max-width: 99vw !important;\n    padding: 10px !important;\n    border-radius: 10px !important;\n  }\n  .modal-content h3, .admin-news-modal-content h3 {\n    font-size: 16px !important;\n    margin-bottom: 10px !important;\n  }\n  .modal-content input, .modal-content textarea, .admin-news-modal-content input, .admin-news-modal-content textarea {\n    font-size: 13px !important;\n    padding: 7px 8px !important;\n    border-radius: 7px !important;\n  }\n  .modal-content button, .admin-news-modal-content button {\n    font-size: 13px !important;\n    padding: 6px 10px !important;\n    border-radius: 7px !important;\n  }\n}\n@media (max-width: 600px) {\n  // --- Модалки admin/rasp ---\n  .modal-overlay, .admin-rasp-modal-overlay {\n    align-items: flex-start !important;\n    padding-top: 30px !important;\n  }\n  .modal-content, .admin-rasp-modal-content {\n    min-width: 96vw !important;\n    max-width: 99vw !important;\n    padding: 10px !important;\n    border-radius: 10px !important;\n    box-shadow: 0 1px 8px #ece9f7 !important;\n  }\n  .modal-content h3, .admin-rasp-modal-content h3 {\n    font-size: 16px !important;\n    margin-bottom: 10px !important;\n  }\n  .modal-content label, .admin-rasp-modal-content label {\n    font-size: 13px !important;\n    margin-bottom: 2px !important;\n  }\n  .modal-content input, .modal-content select, .modal-content textarea,\n  .admin-rasp-modal-content input, .admin-rasp-modal-content select, .admin-rasp-modal-content textarea {\n    font-size: 13px !important;\n    padding: 7px 8px !important;\n    border-radius: 7px !important;\n    margin-bottom: 8px !important;\n  }\n  .modal-content button, .admin-rasp-modal-content button {\n    font-size: 13px !important;\n    padding: 6px 10px !important;\n    border-radius: 7px !important;\n    margin-bottom: 4px !important;\n  }\n  .modal-content .modal-actions, .admin-rasp-modal-content .modal-actions {\n    gap: 8px !important;\n  }\n}\n\n// --- Модалка \"Подробнее о занятии\" ---\n.admin-slot-details-modal-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.3);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.admin-slot-details-modal-content {\n  background: #fff;\n  border-radius: 16px;\n  padding: 24px 18px;\n  min-width: 320px;\n  max-width: 420px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 2px 16px #ece9f7;\n  display: flex;\n  flex-direction: column;\n}\n.admin-slot-details-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n}\n.admin-slot-details-modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  color: #6c3be4;\n}\n.admin-slot-details-modal-close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  color: #6c3be4;\n  cursor: pointer;\n  font-weight: 700;\n}\n.admin-slot-details-modal-info {\n  margin-bottom: 12px;\n  padding: 8px 0;\n  border-bottom: 1px solid #ece9f7;\n}\n.admin-slot-details-modal-time {\n  font-weight: 600;\n  font-size: 16px;\n  color: #222;\n  margin-bottom: 2px;\n}\n.admin-slot-details-modal-subject {\n  font-weight: 500;\n  color: #6c3be4;\n  font-size: 15px;\n}\n.admin-slot-details-modal-meta {\n  margin-bottom: 8px;\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  font-size: 14px;\n}\n.admin-slot-details-modal-comment {\n  margin-bottom: 12px;\n  font-size: 13px;\n  color: #555;\n  background: #f5f5f5;\n  border-radius: 8px;\n  padding: 7px 10px;\n}\n.admin-slot-details-modal-files-title {\n  margin: 14px 0 8px;\n  font-weight: 600;\n  font-size: 15px;\n  color: #222;\n}\n.admin-slot-details-modal-files-list-wrapper {\n  background: #f8f7fc;\n  border-radius: 8px;\n  padding: 8px 6px;\n  margin-bottom: 8px;\n  max-height: 220px;\n  overflow-y: auto;\n}\n.admin-slot-details-modal-user-files {\n  margin-bottom: 14px;\n  background: #f3f0fa;\n  border-radius: 10px;\n  padding: 8px;\n}\n.admin-slot-details-modal-user {\n  font-weight: 600;\n  color: #6c3be4;\n  font-size: 13px;\n  margin-bottom: 6px;\n}\n.admin-slot-details-modal-file-list {\n  padding: 0;\n  list-style: none;\n  margin: 0;\n}\n.admin-slot-details-modal-file-item {\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #fff;\n  border-radius: 7px;\n  padding: 6px;\n  box-shadow: 0 1px 4px #ece9f7;\n}\n.admin-slot-details-modal-file-img {\n  width: 28px;\n  height: 28px;\n  object-fit: cover;\n  border-radius: 5px;\n  box-shadow: 0 1px 3px #ddd;\n}\n.admin-slot-details-modal-file-icon {\n  font-size: 18px;\n  margin-right: 2px;\n}\n.admin-slot-details-modal-file-info {\n  flex: 1 1 0;\n  min-width: 0;\n}\n.admin-slot-details-modal-file-link {\n  color: #6c3be4;\n  text-decoration: underline;\n  font-size: 13px;\n  word-break: break-all;\n  font-weight: 500;\n}\n.admin-slot-details-modal-file-date {\n  color: #888;\n  font-size: 11px;\n  margin-top: 2px;\n}\n.admin-slot-details-modal-file-comment {\n  color: #6c3be4;\n  font-size: 12px;\n  margin-top: 2px;\n}\n.admin-slot-details-modal-file-download {\n  background: #6c3be4;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 5px 10px;\n  font-weight: 500;\n  font-size: 12px;\n  cursor: pointer;\n  text-decoration: none;\n  margin-left: 6px;\n}\n.admin-slot-details-modal-no-files {\n  color: #888;\n  font-size: 13px;\n  margin-left: 8px;\n}\n\n@media (max-width: 600px) {\n  .admin-slot-details-modal-content {\n    min-width: 96vw !important;\n    max-width: 99vw !important;\n    padding: 8px 2px !important;\n    border-radius: 10px !important;\n  }\n  .admin-slot-details-modal-header h2 {\n    font-size: 16px !important;\n  }\n  .admin-slot-details-modal-files-list-wrapper {\n    max-height: 160px !important;\n    padding: 4px 2px !important;\n  }\n  .admin-slot-details-modal-file-img {\n    width: 22px !important;\n    height: 22px !important;\n    border-radius: 4px !important;\n  }\n  .admin-slot-details-modal-file-link {\n    font-size: 12px !important;\n  }\n  .admin-slot-details-modal-file-download {\n    font-size: 11px !important;\n    padding: 4px 7px !important;\n    border-radius: 6px !important;\n  }\n}\n@media (max-width: 600px) {\n  .AdminUserSchedule {\n    padding: 12px 8px 70px 8px !important;\n    background: #f8f7fc;\n    min-height: 100vh;\n  }\n  .AdminUserSchedule__container {\n    padding: 0 !important;\n    margin: 0 !important;\n    width: 100% !important;\n  }\n  .content_admin.admin-user-schedule-wrapper {\n    padding: 0 2px 70px 2px !important;\n    width: 100% !important;\n    margin: 0 !important;\n    box-sizing: border-box;\n  }\n  .admin-user-back-btn {\n    font-size: 13px !important;\n    padding: 6px 10px !important;\n    border-radius: 7px !important;\n    margin-bottom: 10px !important;\n  }\n  .admin-user-title {\n    font-size: 16px !important;\n    margin-bottom: 10px !important;\n    word-break: break-word;\n  }\n  .AdminSchedule-kanban {\n    flex-direction: row !important;\n    gap: 8px !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 16px;\n    margin-bottom: 0;\n    width: 100%;\n    max-width: 100vw;\n  }\n  .Schedule__column {\n    min-width: 160px !important;\n    max-width: 220px !important;\n    width: 90vw !important;\n    font-size: 12px !important;\n  }\n  .ScheduleBlock, .ScheduleBlock.filled, .ScheduleBlock.empty {\n    width: 100% !important;\n    padding: 10px !important;\n    font-size: 12px !important;\n    border-radius: 8px !important;\n    margin-bottom: 10px !important;\n  }\n}\n\n// --- Адаптив для страницы профиля ученика ---\n@media (max-width: 900px) {\n  .AdminUserFull__container {\n    flex-direction: column !important;\n    padding: 0 !important;\n  }\n  .admin-user-full-wrapper {\n    flex-direction: column !important;\n    gap: 0 !important;\n    margin: 0 !important;\n    padding: 0 0 60px 0 !important;\n  }\n  .admin-user-full-info {\n    padding: 16px 10px 18px 10px !important;\n    background: #fafaff;\n    border-radius: 12px;\n    box-shadow: 0 1px 8px #ece9f7;\n    margin-bottom: 18px !important;\n    font-size: 15px !important;\n  }\n  .admin-user-title {\n    font-size: 20px !important;\n    margin-bottom: 12px !important;\n    text-align: left !important;\n  }\n  .admin-user-back-btn {\n    margin: 10px 0 0 0 !important;\n    font-size: 15px !important;\n    padding: 7px 18px !important;\n  }\n  .admin-user-full-info input,\n  .admin-user-full-info button {\n    font-size: 15px !important;\n    padding: 7px 12px !important;\n    min-width: 0 !important;\n    width: 100%;\n    margin-bottom: 8px;\n  }\n  .admin-user-full-info label {\n    font-size: 15px !important;\n    min-width: 60px !important;\n  }\n  .admin-user-full-info ul {\n    max-width: 100% !important;\n    overflow-x: auto;\n  }\n  .admin-user-full-info li {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 8px !important;\n    padding: 10px !important;\n    font-size: 14px !important;\n  }\n  .admin-user-full-info h3 {\n    font-size: 17px !important;\n    margin-bottom: 10px !important;\n  }\n  .admin-user-full-info a {\n    font-size: 15px !important;\n    word-break: break-all;\n  }\n  .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info button {\n    margin-bottom: 8px !important;\n  }\n  .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info .admin-user-full-info {\n    padding: 0 !important;\n  }\n}\n.admin-user-full-flex {\n  display: flex;\n  gap: 40px;\n  align-items: flex-start;\n  margin-top: 24px;\n}\n\n@media (max-width: 900px) {\n  .admin-user-full-flex {\n    flex-direction: column !important;\n    gap: 0 !important;\n    margin-top: 10px !important;\n  }\n  .admin-user-full-info {\n    margin-bottom: 16px !important;\n  }\n  .content_admin .admin-user-full-wrapper > .admin-user-full-flex > div {\n    min-width: 0 !important;\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n  .content_admin .admin-user-full-wrapper > .admin-user-full-flex > div:last-child {\n    margin-left: 0 !important;\n    margin-top: 18px !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    width: 100% !important;\n    padding: 18px 8px !important;\n    box-sizing: border-box;\n  }\n}\n.admin-user-full-name-row {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-top: 6px;\n}\n\n@media (max-width: 900px) {\n  .admin-user-full-name-row {\n    flex-direction: column !important;\n    gap: 8px !important;\n    align-items: stretch !important;\n    margin-top: 6px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
